import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ActiveValueChainMutationResponse = MutationResponse & {
  __typename?: 'ActiveValueChainMutationResponse';
  data?: Maybe<ValueChain>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type ActivityNodeResponse = {
  __typename?: 'ActivityNodeResponse';
  data?: Maybe<ActivityPlanningMutationData>;
  errors?: Maybe<Array<Maybe<FieldError>>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type ActivityPlaningNode = {
  __typename?: 'ActivityPlaningNode';
  activityValueChainId?: Maybe<Scalars['ID']['output']>;
  auditManagerId?: Maybe<Scalars['String']['output']>;
  auditPlanName?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['Float']['output']>;
  btaType?: Maybe<Scalars['String']['output']>;
  dashboardId?: Maybe<Scalars['ID']['output']>;
  demand?: Maybe<Scalars['Float']['output']>;
  difference?: Maybe<Scalars['Float']['output']>;
  engagement?: Maybe<Scalars['Boolean']['output']>;
  engagementManagerId?: Maybe<Scalars['String']['output']>;
  engagementName?: Maybe<Scalars['String']['output']>;
  engagementStatus?: Maybe<Scalars['String']['output']>;
  engagementTypeOfThematicAudit?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['String']['output']>;
  expectedStartingDate?: Maybe<Scalars['String']['output']>;
  ghoAuditType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legalEntityCode?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  legalEntityTrackingId?: Maybe<Scalars['String']['output']>;
  lentedAllocationViews?: Maybe<Array<Maybe<LentedAllocationView>>>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  permission?: Maybe<PermissionType>;
  proposalAdded?: Maybe<Scalars['String']['output']>;
  proposalTrackingId?: Maybe<Scalars['String']['output']>;
  proposedDemand?: Maybe<Scalars['Float']['output']>;
  smartcode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subnodes?: Maybe<Array<Maybe<ActivityPlaningNode>>>;
  typeOfAudit?: Maybe<Scalars['String']['output']>;
};

export type ActivityPlanningDashboard = {
  __typename?: 'ActivityPlanningDashboard';
  filters?: Maybe<Array<Maybe<FilterStructure>>>;
  items: Array<Maybe<OuActivityPlanning>>;
  pageInfo: PageInfo;
};

export type ActivityPlanningModuleInput = {
  dashboardId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type ActivityPlanningMutationData = {
  __typename?: 'ActivityPlanningMutationData';
  nodes?: Maybe<Array<Maybe<ActivityPlaningNode>>>;
  totalAvailability?: Maybe<Scalars['Float']['output']>;
  totalDemand?: Maybe<Scalars['Float']['output']>;
  totalDifference?: Maybe<Scalars['Float']['output']>;
};

export type ActivityPlanningRequestInput = {
  campaignId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type ActivityPlanningResponse = {
  __typename?: 'ActivityPlanningResponse';
  filters?: Maybe<Array<Maybe<FilterStructure>>>;
  nodes?: Maybe<Array<Maybe<ActivityPlaningNode>>>;
  totalAvailability?: Maybe<Scalars['Float']['output']>;
  totalDemand?: Maybe<Scalars['Float']['output']>;
  totalDifference?: Maybe<Scalars['Float']['output']>;
};

export type ActivityValueChain = {
  __typename?: 'ActivityValueChain';
  active?: Maybe<Scalars['Boolean']['output']>;
  campaign?: Maybe<Campaign>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ActivityValueChain>;
};

export enum ActivityValueChainFields {
  Active = 'ACTIVE',
  Description = 'DESCRIPTION',
  Level = 'LEVEL',
  Name = 'NAME'
}

export type AddCapacityExternalUserInput = {
  resourceInput: ResourceCategoryInsert;
  teamMemberId: Scalars['ID']['input'];
};

export type AddCapacityFeatureNewOnboardingUserInput = {
  galtMemberId: Scalars['ID']['input'];
  resourceInput: ResourceCategoryInsert;
  teamMemberName: Scalars['ID']['input'];
};

export type AddLevel3ActivityInput = {
  dashboardId: Scalars['ID']['input'];
  demand?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
};

export type AggregateQueryInput = {
  filters: Array<SimpleQueryInput>;
  orderBy?: InputMaybe<OrderByInput>;
};

export type AllocationChangesPayload = {
  __typename?: 'AllocationChangesPayload';
  changes?: Maybe<Array<Maybe<CapacityActivityAllocation>>>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  totals?: Maybe<CapacityPlanTotals>;
};

export type AllocationInput = {
  md?: InputMaybe<Scalars['Float']['input']>;
  month?: InputMaybe<Month>;
};

export enum AuditTeam {
  BusinessAudit = 'BUSINESS_AUDIT',
  TeamB = 'TEAM_B',
  TeamC = 'TEAM_C'
}

export type AvailableGhoContactTypesInput = {
  activityValueChainId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  capacityPlanningId?: InputMaybe<Scalars['ID']['input']>;
  organizationalUnit: Scalars['ID']['input'];
};

export type BulkSaveLentedAllocationsInput = {
  deletes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  upserts?: InputMaybe<Array<InputMaybe<LentedAllocationUpsertInput>>>;
};

export type BulkSaveLentedAllocationsPayload = {
  __typename?: 'BulkSaveLentedAllocationsPayload';
  deleteResults?: Maybe<Array<Maybe<DeleteResult>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  upsertResults?: Maybe<Array<Maybe<UpsertResult>>>;
};

export type Campaign = {
  __typename?: 'Campaign';
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<CampaignStatus>;
  type?: Maybe<CampaignType>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CampaignMutationResponse = MutationResponse & {
  __typename?: 'CampaignMutationResponse';
  data?: Maybe<Campaign>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export enum CampaignStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export enum CampaignType {
  Activity = 'ACTIVITY',
  Planning = 'PLANNING',
  Scheduling = 'SCHEDULING',
  Timesheet = 'TIMESHEET'
}

export type CampaignTypeInput = {
  type: CampaignType;
};

export type Campaigns = {
  __typename?: 'Campaigns';
  items: Array<Campaign>;
  pageInfo: PageInfo;
};

export type CapacityActivityAllocation = {
  __typename?: 'CapacityActivityAllocation';
  activityValueChain?: Maybe<ActivityValueChain>;
  capacityPlanningId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lentedAllocation?: Maybe<Scalars['Float']['output']>;
  manDaysAllocation?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CapacityActivityAllocationMutationResponse = {
  __typename?: 'CapacityActivityAllocationMutationResponse';
  data?: Maybe<UpdateCapacityActivityAllocationPayload>;
  errors?: Maybe<Array<Maybe<FieldError>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MutationStatus>;
};

export type CapacityActivityAllocationSum = {
  __typename?: 'CapacityActivityAllocationSum';
  activityAllocationList?: Maybe<Array<Maybe<CapacityActivityAllocation>>>;
  capacityType?: Maybe<Scalars['String']['output']>;
  totals?: Maybe<CapacityActivityAllocationSumTotals>;
};

export type CapacityActivityAllocationSumTotals = {
  __typename?: 'CapacityActivityAllocationSumTotals';
  totalAvailabilityCheck?: Maybe<Scalars['Boolean']['output']>;
  totalLented?: Maybe<Scalars['Float']['output']>;
  totalSummedAvailability?: Maybe<Scalars['Float']['output']>;
};

export enum CapacityLegalEntityFields {
  ActualInternalAuditor = 'ACTUAL_INTERNAL_AUDITOR',
  BusinessUnit = 'BUSINESS_UNIT',
  Code = 'CODE',
  ExternalSupport = 'EXTERNAL_SUPPORT',
  FutureNewOnboarding = 'FUTURE_NEW_ONBOARDING',
  LastValidationDate = 'LAST_VALIDATION_DATE',
  LocalChiefValidation = 'LOCAL_CHIEF_VALIDATION',
  Name = 'NAME',
  OrganizationalUnit = 'ORGANIZATIONAL_UNIT',
  ResourceAllocated = 'RESOURCE_ALLOCATED',
  Status = 'STATUS',
  TotalAvailabilityMd = 'TOTAL_AVAILABILITY_MD',
  TotalTypeOfContact = 'TOTAL_TYPE_OF_CONTACT',
  UnknownExternalSupport = 'UNKNOWN_EXTERNAL_SUPPORT'
}

export type CapacityPlan = {
  __typename?: 'CapacityPlan';
  blockedPlanning?: Maybe<Scalars['Boolean']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  capacityActivityAllocations?: Maybe<Array<Maybe<CapacityActivityAllocation>>>;
  difference?: Maybe<Scalars['Float']['output']>;
  endPeriodDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<PermissionType>;
  proposedTotalAvailability?: Maybe<Scalars['Float']['output']>;
  startPeriodDate?: Maybe<Scalars['String']['output']>;
  teamMember?: Maybe<UserProfile>;
  totalAvailabilityCheck?: Maybe<Scalars['Boolean']['output']>;
  totalAvailabilityInput?: Maybe<Scalars['Float']['output']>;
  totalSummedAvailability?: Maybe<Scalars['Float']['output']>;
  workContractAvailability?: Maybe<Scalars['Float']['output']>;
};

export type CapacityPlanMutationResponse = {
  __typename?: 'CapacityPlanMutationResponse';
  data?: Maybe<CapacityPlan>;
  errors?: Maybe<Array<Maybe<FieldError>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MutationStatus>;
};

export type CapacityPlanTotals = {
  __typename?: 'CapacityPlanTotals';
  blockedPlanning?: Maybe<Scalars['Boolean']['output']>;
  difference?: Maybe<Scalars['Float']['output']>;
  endPeriodDate?: Maybe<Scalars['String']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  proposedTotalAvailability?: Maybe<Scalars['Float']['output']>;
  startPeriodDate?: Maybe<Scalars['String']['output']>;
  totalAvailabilityCheck?: Maybe<Scalars['Boolean']['output']>;
  totalAvailabilityInput?: Maybe<Scalars['Float']['output']>;
  totalSummedAvailability?: Maybe<Scalars['Float']['output']>;
  workContractAvailability?: Maybe<Scalars['Float']['output']>;
};

export type CapacityPlanning = {
  __typename?: 'CapacityPlanning';
  filters?: Maybe<Array<Maybe<FilterStructure>>>;
  items: Array<Maybe<LegalEntityCapacityPlanning>>;
  pageInfo: PageInfo;
};

export type CapacityPlanningAddTeamMemberResponse = MutationResponse & {
  __typename?: 'CapacityPlanningAddTeamMemberResponse';
  data: CapacityPlan;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type CapacityPlanningLeValidationInput = {
  capacityLegalEntityId: Scalars['ID']['input'];
};

export type CapacityPlanningRequestInput = {
  campaignId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type CapacityPlanningUpdateResponse = MutationResponse & {
  __typename?: 'CapacityPlanningUpdateResponse';
  data: LegalEntityCapacityPlanning;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export enum CapacityType {
  ActualInternalAuditor = 'ACTUAL_INTERNAL_AUDITOR',
  ExternalSupport = 'EXTERNAL_SUPPORT',
  FutureNewOnboarding = 'FUTURE_NEW_ONBOARDING'
}

export type CapacityUserAssignmentInput = {
  OuSchedulingID: Scalars['ID']['input'];
  scheduledCapacityPlanningId: Array<InputMaybe<Scalars['ID']['input']>>;
};

export enum ComparatorOperators {
  /**  Less than or equal */
  Contains = 'CONTAINS',
  /**  String starts with */
  EndsWith = 'ENDS_WITH',
  Eq = 'EQ',
  /**  Not equal */
  Gt = 'GT',
  /**  Less than */
  Gte = 'GTE',
  /**  Greater than */
  Lt = 'LT',
  /**  Greater than or equal */
  Lte = 'LTE',
  /**  String ends with */
  Match = 'MATCH',
  /**  Equal */
  Neq = 'NEQ',
  /**  String contains */
  StartsWith = 'STARTS_WITH'
}

export type ConnectionInfo = {
  edges: Array<Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateCampaignInput = {
  type: CampaignType;
  year: Scalars['Int']['input'];
};

export type CreateLegalEntityInput = {
  businessUnit?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  legalEntityTrackingId?: InputMaybe<Scalars['String']['input']>;
  macroBusinessUnit?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sizeScore?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewValueChainInput = {
  campaignId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  legalEntityId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type DeleteLevel3ActivityInput = {
  activityPlanningId: Scalars['ID']['input'];
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DownloadActivityPlanningResponse = {
  __typename?: 'DownloadActivityPlanningResponse';
  data?: Maybe<DownloadFile>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type DownloadCapacityPlanningResponse = {
  __typename?: 'DownloadCapacityPlanningResponse';
  data?: Maybe<DownloadFile>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type DownloadFile = {
  __typename?: 'DownloadFile';
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type Edge = {
  /**  node: Oggetto! */
  cursor: Scalars['String']['output'];
};

export type FieldError = {
  __typename?: 'FieldError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type FilterStructure = {
  __typename?: 'FilterStructure';
  filterValue?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
};

export type GetActivityCapacityInput = {
  OuSchedulingID: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type GetMaxUtilizationInput = {
  dashboardId: Scalars['ID']['input'];
};

export type GetOuSchedulingInput = {
  campaignId: Scalars['ID']['input'];
};

export type GetSchedulerInput = {
  dashboardId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type GetSchedulerUserInput = {
  dashboardId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
  schedulingUserId: Scalars['ID']['input'];
};

export type GetSchedulingAllocationInput = {
  ouSchedulingNodeId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type LegalEntities = {
  __typename?: 'LegalEntities';
  items: Array<LegalEntity>;
  pageInfo: PageInfo;
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  businessUnit?: Maybe<Scalars['String']['output']>;
  chiefAuditor?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legalEntityTrackingId?: Maybe<Scalars['String']['output']>;
  macroBusinessUnit?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationalUnit?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sizeScore?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LegalEntityCapacityPlanning = {
  __typename?: 'LegalEntityCapacityPlanning';
  actualInternalAuditors?: Maybe<Scalars['Int']['output']>;
  canValidate?: Maybe<Scalars['Boolean']['output']>;
  externalSupport?: Maybe<Scalars['Int']['output']>;
  futureNewOnboarding?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastValidationDate?: Maybe<Scalars['String']['output']>;
  lastValidationUser?: Maybe<Scalars['String']['output']>;
  leCapacityPlanningStatus?: Maybe<Scalars['String']['output']>;
  legalEntity?: Maybe<LegalEntity>;
  localChiefValidation?: Maybe<Scalars['Boolean']['output']>;
  resourceAllocated?: Maybe<Scalars['Float']['output']>;
  totalAvailabilityMD?: Maybe<Scalars['Int']['output']>;
  totalTypeOfContact?: Maybe<Scalars['Int']['output']>;
  unknownExternalSupport?: Maybe<Scalars['Int']['output']>;
};

export type LegalEntityMutationResponse = MutationResponse & {
  __typename?: 'LegalEntityMutationResponse';
  data?: Maybe<LegalEntity>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type LentedAllocation = {
  __typename?: 'LentedAllocation';
  activityValueChain?: Maybe<ActivityValueChain>;
  capacityPlanningId?: Maybe<Scalars['ID']['output']>;
  ghoContactType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalEntityId?: Maybe<Scalars['ID']['output']>;
  manDaysAllocation?: Maybe<Scalars['Float']['output']>;
  organizationalUnit?: Maybe<Scalars['ID']['output']>;
};

export type LentedAllocationCapacityInput = {
  allocationPlanningId: Scalars['ID']['input'];
};

export type LentedAllocationMutationResponse = {
  __typename?: 'LentedAllocationMutationResponse';
  data?: Maybe<LentedAllocation>;
  errors?: Maybe<Array<Maybe<FieldError>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MutationStatus>;
};

export type LentedAllocationUpsertInput = {
  activityValueChainId?: InputMaybe<Scalars['ID']['input']>;
  allocationPlanningId?: InputMaybe<Scalars['ID']['input']>;
  capacityPlanningId: Scalars['ID']['input'];
  ghoContactType?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  manDaysAllocation?: InputMaybe<Scalars['Float']['input']>;
  organizationalUnit?: InputMaybe<Scalars['ID']['input']>;
};

export type LentedAllocationView = {
  __typename?: 'LentedAllocationView';
  mdAllocation?: Maybe<Scalars['Float']['output']>;
  ou?: Maybe<Scalars['String']['output']>;
};

export enum Month {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export type MonthlyBreakdown = {
  __typename?: 'MonthlyBreakdown';
  APRIL?: Maybe<Scalars['Float']['output']>;
  AUGUST?: Maybe<Scalars['Float']['output']>;
  DECEMBER?: Maybe<Scalars['Float']['output']>;
  FEBRUARY?: Maybe<Scalars['Float']['output']>;
  JANUARY?: Maybe<Scalars['Float']['output']>;
  JULY?: Maybe<Scalars['Float']['output']>;
  JUNE?: Maybe<Scalars['Float']['output']>;
  MARCH?: Maybe<Scalars['Float']['output']>;
  MAY?: Maybe<Scalars['Float']['output']>;
  NOVEMBER?: Maybe<Scalars['Float']['output']>;
  OCTOBER?: Maybe<Scalars['Float']['output']>;
  SEPTEMBER?: Maybe<Scalars['Float']['output']>;
};

export type MonthlyBreakdownInput = {
  APRIL?: InputMaybe<Scalars['Float']['input']>;
  AUGUST?: InputMaybe<Scalars['Float']['input']>;
  DECEMBER?: InputMaybe<Scalars['Float']['input']>;
  FEBRUARY?: InputMaybe<Scalars['Float']['input']>;
  JANUARY?: InputMaybe<Scalars['Float']['input']>;
  JULY?: InputMaybe<Scalars['Float']['input']>;
  JUNE?: InputMaybe<Scalars['Float']['input']>;
  MARCH?: InputMaybe<Scalars['Float']['input']>;
  MAY?: InputMaybe<Scalars['Float']['input']>;
  NOVEMBER?: InputMaybe<Scalars['Float']['input']>;
  OCTOBER?: InputMaybe<Scalars['Float']['input']>;
  SEPTEMBER?: InputMaybe<Scalars['Float']['input']>;
};

export type MultipleUpdateSchedulingAllocationRequest = {
  requests?: InputMaybe<Array<InputMaybe<UpdateSchedulingAllocationRequest>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExternalTeamMemberToCapacityCampaign?: Maybe<CapacityPlanningAddTeamMemberResponse>;
  addFeatureNewOnboardingTeamMemberToCapacityCampaign?: Maybe<CapacityPlanningAddTeamMemberResponse>;
  addLevel3Activity: ActivityNodeResponse;
  bulkSaveLentedAllocations?: Maybe<BulkSaveLentedAllocationsPayload>;
  createCampaign: CampaignMutationResponse;
  createLegalEntity: LegalEntityMutationResponse;
  createNewValueChain: ActiveValueChainMutationResponse;
  createUser: UserMutationResponse;
  deleteLegalEntity: LegalEntityMutationResponse;
  deleteLentedAllocation?: Maybe<LentedAllocationMutationResponse>;
  deleteLevel3Activity: ActivityNodeResponse;
  deleteTeamMemberFromCapacityCampaign?: Maybe<CapacityPlanningAddTeamMemberResponse>;
  deleteUser: UserMutationResponse;
  deleteValueChain?: Maybe<ActiveValueChainMutationResponse>;
  downloadActivityPlanningDashboardExcel: DownloadActivityPlanningResponse;
  downloadActivityPlanningExcel: DownloadActivityPlanningResponse;
  downloadActivityValueChainExcel: DownloadCapacityPlanningResponse;
  downloadCapacityPlanningExcel: DownloadCapacityPlanningResponse;
  downloadLeCapacityPlanningExcel: DownloadCapacityPlanningResponse;
  downloadSchedulingActivityExcel: DownloadCapacityPlanningResponse;
  downloadSchedulingAllocationExcel: DownloadCapacityPlanningResponse;
  downloadSchedulingUserDashboardView: DownloadCapacityPlanningResponse;
  downloadSchedulingUserView: DownloadCapacityPlanningResponse;
  renamePlaceHolderTeamMemberInCapacityCampaign?: Maybe<CapacityPlanningAddTeamMemberResponse>;
  swapExternalTeamMemberInCapacityCampaign?: Maybe<CapacityPlanningAddTeamMemberResponse>;
  swapPlaceHolderToExternalTeamMemberInCapacityCampaign?: Maybe<CapacityPlanningAddTeamMemberResponse>;
  updateCampaign: CampaignMutationResponse;
  updateCapacityActivityAllocation?: Maybe<CapacityActivityAllocationMutationResponse>;
  updateDemandActivity: ActivityNodeResponse;
  updateLegalEntity: LegalEntityMutationResponse;
  updateLentedAllocation?: Maybe<LentedAllocationMutationResponse>;
  updateLevel3Name: ActivityNodeResponse;
  updateManDaysMaxUtilization: SchedulingMaxUtilizationResponse;
  updateSchedulingAllocation?: Maybe<SchedulingTotalsAllocationResponse>;
  updateSchedulingCapacityUserAssignment: SchedulingGetCapacityUserAssignmentResponse;
  updateTeamMemberCapacityPlan?: Maybe<CapacityPlanMutationResponse>;
  updateUser: UserMutationResponse;
  updateValueChain: ActiveValueChainMutationResponse;
  validateLeCapacityPlanning: CapacityPlanningUpdateResponse;
};


export type MutationAddExternalTeamMemberToCapacityCampaignArgs = {
  request?: InputMaybe<AddCapacityExternalUserInput>;
};


export type MutationAddFeatureNewOnboardingTeamMemberToCapacityCampaignArgs = {
  request?: InputMaybe<AddCapacityFeatureNewOnboardingUserInput>;
};


export type MutationAddLevel3ActivityArgs = {
  input: AddLevel3ActivityInput;
};


export type MutationBulkSaveLentedAllocationsArgs = {
  input?: InputMaybe<BulkSaveLentedAllocationsInput>;
};


export type MutationCreateCampaignArgs = {
  request: CreateCampaignInput;
};


export type MutationCreateLegalEntityArgs = {
  input: CreateLegalEntityInput;
};


export type MutationCreateNewValueChainArgs = {
  input: CreateNewValueChainInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteLegalEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLentedAllocationArgs = {
  input?: InputMaybe<LentedAllocationCapacityInput>;
};


export type MutationDeleteLevel3ActivityArgs = {
  input: DeleteLevel3ActivityInput;
};


export type MutationDeleteTeamMemberFromCapacityCampaignArgs = {
  capacityPlanningId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteValueChainArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDownloadActivityPlanningDashboardExcelArgs = {
  request?: InputMaybe<ActivityPlanningRequestInput>;
};


export type MutationDownloadActivityPlanningExcelArgs = {
  request: ActivityPlanningModuleInput;
};


export type MutationDownloadActivityValueChainExcelArgs = {
  request?: InputMaybe<ValueChainsRequestInput>;
};


export type MutationDownloadCapacityPlanningExcelArgs = {
  request?: InputMaybe<ResourceCategory>;
};


export type MutationDownloadLeCapacityPlanningExcelArgs = {
  request: CapacityPlanningRequestInput;
};


export type MutationDownloadSchedulingActivityExcelArgs = {
  request?: InputMaybe<GetSchedulerInput>;
};


export type MutationDownloadSchedulingAllocationExcelArgs = {
  request?: InputMaybe<GetSchedulingAllocationInput>;
};


export type MutationDownloadSchedulingUserDashboardViewArgs = {
  request?: InputMaybe<GetSchedulerInput>;
};


export type MutationDownloadSchedulingUserViewArgs = {
  request?: InputMaybe<GetSchedulerUserInput>;
};


export type MutationRenamePlaceHolderTeamMemberInCapacityCampaignArgs = {
  request?: InputMaybe<RenameFeatureNewOnboardingTeamMemberInCapacityCampaignInput>;
};


export type MutationSwapExternalTeamMemberInCapacityCampaignArgs = {
  request?: InputMaybe<SwapExternalTeamMemberInCapacityCampaignInput>;
};


export type MutationSwapPlaceHolderToExternalTeamMemberInCapacityCampaignArgs = {
  request?: InputMaybe<SwapExternalTeamMemberInCapacityCampaignInput>;
};


export type MutationUpdateCampaignArgs = {
  request: UpdateCampaignInput;
};


export type MutationUpdateCapacityActivityAllocationArgs = {
  input?: InputMaybe<UpdateCapacityActivityAllocationInput>;
};


export type MutationUpdateDemandActivityArgs = {
  input: UpdateDemandActivityInput;
};


export type MutationUpdateLegalEntityArgs = {
  input: UpdateLegalEntityInput;
};


export type MutationUpdateLentedAllocationArgs = {
  input?: InputMaybe<UpdateLentedAllocationInput>;
};


export type MutationUpdateLevel3NameArgs = {
  input?: InputMaybe<UpdateLevel3NameInput>;
};


export type MutationUpdateManDaysMaxUtilizationArgs = {
  request?: InputMaybe<UpdateManDaysMaxUtilizationInput>;
};


export type MutationUpdateSchedulingAllocationArgs = {
  request?: InputMaybe<MultipleUpdateSchedulingAllocationRequest>;
};


export type MutationUpdateSchedulingCapacityUserAssignmentArgs = {
  request?: InputMaybe<CapacityUserAssignmentInput>;
};


export type MutationUpdateTeamMemberCapacityPlanArgs = {
  input?: InputMaybe<UpdateTeamMemberCapacityPlanInput>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateValueChainArgs = {
  input: UpdateValueChainInput;
};


export type MutationValidateLeCapacityPlanningArgs = {
  request: CapacityPlanningLeValidationInput;
};

export type MutationResponse = {
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export enum MutationStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
  ValidationError = 'VALIDATION_ERROR'
}

export type OrderByInput = {
  field: Scalars['String']['input'];
  order: OrderTypeInput;
};

export enum OrderTypeInput {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OuActivityPlanning = {
  __typename?: 'OuActivityPlanning';
  businessUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organizationalUnit?: Maybe<Scalars['String']['output']>;
  totalAvailability?: Maybe<Scalars['Float']['output']>;
  totalDemand?: Maybe<Scalars['Float']['output']>;
  totalDifference?: Maybe<Scalars['Float']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageRequest = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export enum PermissionType {
  O = 'O',
  R = 'R'
}

export enum PlanningRoles {
  Auditor = 'AUDITOR',
  CapacityPlanningManager = 'CAPACITY_PLANNING_MANAGER',
  ExternalConsultant = 'EXTERNAL_CONSULTANT',
  Gcao = 'GCAO',
  Gcao_1 = 'GCAO_1',
  LocalChief = 'LOCAL_CHIEF',
  PeopleManager = 'PEOPLE_MANAGER'
}

export type Query = {
  __typename?: 'Query';
  activityPlanning: ActivityPlanningResponse;
  activityValueChains: ValueChains;
  allocationChanges?: Maybe<AllocationChangesPayload>;
  /**
   *  GHO contact types selectable as a lending destination. Only populated for a GHO
   *  organizational unit (e.g. Group Head Office) on the "Audit Execution" activity.
   */
  availableGhoContactTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  campaignByType?: Maybe<Campaign>;
  campaignsByType?: Maybe<Campaigns>;
  capacityActivityAllocationSum?: Maybe<Array<Maybe<CapacityActivityAllocationSum>>>;
  externalPeopleManagerForTeamMembersToBeAdded?: Maybe<Resources>;
  externalTeamMembersToBeAdded?: Maybe<TeamMembers>;
  getSchedulingActivityAllocationDetails: SchedulingTotalsAllocationResponse;
  getSchedulingActivityByOu: SchedulingActivityResponse;
  getSchedulingCapacityUserAssignment: SchedulingGetCapacityUserAssignmentResponse;
  leCapacityPlanning: CapacityPlanning;
  legalEntities: LegalEntities;
  legalEntityById?: Maybe<LegalEntity>;
  ouActivityPlanning: ActivityPlanningDashboard;
  resourceAuditTeams?: Maybe<Resources>;
  resourceGaltMember?: Maybe<Resources>;
  resourceLegalEntities?: Maybe<ResourcesWithPermission>;
  resourceOrganizationalUnits?: Maybe<Resources>;
  /** Torna id null perche organizzationalUnit viene recuperato con un distinct sulle legalEntity */
  resourceOrganizationalUnitsComplete?: Maybe<Resources>;
  resourcePeopleManagers?: Maybe<Resources>;
  schedulingFindAllOuByCampaignId: SchedulingDashboardResponse;
  schedulingMaxUtilization: SchedulingMaxUtilizationResponse;
  /**  FLAT VIEW. */
  schedulingUserDashboardView?: Maybe<SchedulingTotalsAllocationResponse>;
  schedulingUserView?: Maybe<SchedulingTotalsAllocationResponse>;
  teamMemberCapacityPlan?: Maybe<CapacityPlan>;
  teamMemberLentedAllocation?: Maybe<Array<Maybe<LentedAllocation>>>;
  teamMembersByResourceCategory?: Maybe<TeamMemberCapacityPlans>;
  userById?: Maybe<User>;
  userByUsername?: Maybe<User>;
  userRolePlannerTool?: Maybe<UserRole>;
  users: Users;
  usersConnection: UserConnection;
  usersProfile: UsersProfileResponse;
};


export type QueryActivityPlanningArgs = {
  request: ActivityPlanningModuleInput;
};


export type QueryActivityValueChainsArgs = {
  request?: InputMaybe<ValueChainsRequestInput>;
};


export type QueryAllocationChangesArgs = {
  planId: Scalars['ID']['input'];
  since: Scalars['String']['input'];
};


export type QueryAvailableGhoContactTypesArgs = {
  request?: InputMaybe<AvailableGhoContactTypesInput>;
};


export type QueryCampaignByTypeArgs = {
  type: CampaignType;
  year: Scalars['Int']['input'];
};


export type QueryCampaignsByTypeArgs = {
  type: CampaignType;
};


export type QueryCapacityActivityAllocationSumArgs = {
  campaignId: Scalars['ID']['input'];
  capacityType?: InputMaybe<CapacityType>;
  legalEntityId: Scalars['ID']['input'];
  peopleManagerIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryExternalPeopleManagerForTeamMembersToBeAddedArgs = {
  request?: InputMaybe<ResourceCategory>;
};


export type QueryExternalTeamMembersToBeAddedArgs = {
  request?: InputMaybe<ResourceCategory>;
};


export type QueryGetSchedulingActivityAllocationDetailsArgs = {
  request?: InputMaybe<GetSchedulingAllocationInput>;
};


export type QueryGetSchedulingActivityByOuArgs = {
  request?: InputMaybe<GetSchedulerInput>;
};


export type QueryGetSchedulingCapacityUserAssignmentArgs = {
  request?: InputMaybe<GetActivityCapacityInput>;
};


export type QueryLeCapacityPlanningArgs = {
  request: CapacityPlanningRequestInput;
};


export type QueryLegalEntitiesArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryLegalEntityByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOuActivityPlanningArgs = {
  request: ActivityPlanningRequestInput;
};


export type QueryResourceAuditTeamsArgs = {
  request: ResourceAuditTeam;
};


export type QueryResourceGaltMemberArgs = {
  request: ResourceLe;
};


export type QueryResourceLegalEntitiesArgs = {
  request: ResourceLe;
};


export type QueryResourceOrganizationalUnitsArgs = {
  request: ResourceOu;
};


export type QueryResourceOrganizationalUnitsCompleteArgs = {
  request: ResourceLe;
};


export type QueryResourcePeopleManagersArgs = {
  request: ResourcePeopleManager;
};


export type QuerySchedulingFindAllOuByCampaignIdArgs = {
  request: GetOuSchedulingInput;
};


export type QuerySchedulingMaxUtilizationArgs = {
  request: GetMaxUtilizationInput;
};


export type QuerySchedulingUserDashboardViewArgs = {
  request?: InputMaybe<GetSchedulerInput>;
};


export type QuerySchedulingUserViewArgs = {
  request?: InputMaybe<GetSchedulerUserInput>;
};


export type QueryTeamMemberCapacityPlanArgs = {
  request?: InputMaybe<TeamMemberCapacityInput>;
};


export type QueryTeamMemberLentedAllocationArgs = {
  request?: InputMaybe<TeamMemberCapacityInput>;
};


export type QueryTeamMembersByResourceCategoryArgs = {
  request?: InputMaybe<ResourceCategory>;
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByUsernameArgs = {
  username: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  input: UsersQueryInput;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersProfileArgs = {
  request: UsersQueryInput;
};

export type RenameFeatureNewOnboardingTeamMemberInCapacityCampaignInput = {
  capacityPlanningId: Scalars['ID']['input'];
  galtMemberId: Scalars['ID']['input'];
  newTeamMemberName: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResourceAuditTeam = {
  campaignId: Scalars['ID']['input'];
  legalEntitySelected: Scalars['ID']['input'];
  peopleManagerSelected: Scalars['ID']['input'];
};

export type ResourceCategory = {
  campaignId: Scalars['ID']['input'];
  /** auditTeam: [AuditTeam]! */
  capacityType: CapacityType;
  /**  When true, restrict people managers to those with existing not-yet-planned users of the capacity type */
  existing?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ResourceCategoryInsert = {
  campaignId: Scalars['ID']['input'];
  /** auditTeam: [AuditTeam]! */
  capacityType: CapacityType;
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResourceLe = {
  campaignId: Scalars['ID']['input'];
  organizationalUnitSelected: Scalars['String']['input'];
};

export type ResourceOu = {
  campaignId: Scalars['ID']['input'];
};

export type ResourcePeopleManager = {
  campaignId: Scalars['ID']['input'];
  legalEntitySelected: Scalars['ID']['input'];
};

export type ResourceType = {
  __typename?: 'ResourceType';
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ResourceTypeWithPermissio = {
  __typename?: 'ResourceTypeWithPermissio';
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<PermissionType>;
};

export type Resources = {
  __typename?: 'Resources';
  data?: Maybe<Array<Maybe<ResourceType>>>;
};

export type ResourcesWithPermission = {
  __typename?: 'ResourcesWithPermission';
  data?: Maybe<Array<Maybe<ResourceTypeWithPermissio>>>;
};

export type SchedulingActivityNodes = {
  __typename?: 'SchedulingActivityNodes';
  activityValueChainId?: Maybe<Scalars['ID']['output']>;
  dashboardId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  permission?: Maybe<PermissionType>;
  schedulingRow?: Maybe<SchedulingRow>;
  subnodes?: Maybe<Array<Maybe<SchedulingActivityNodes>>>;
  userAssignment?: Maybe<Array<Maybe<UserAssignment>>>;
};

export type SchedulingActivityResponse = {
  __typename?: 'SchedulingActivityResponse';
  filters?: Maybe<Array<Maybe<FilterStructure>>>;
  monthLimits?: Maybe<SchedulingMaxUtilizationResponse>;
  nodes?: Maybe<Array<Maybe<SchedulingActivityNodes>>>;
};

export type SchedulingDashboard = {
  __typename?: 'SchedulingDashboard';
  businessUnit?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationalUnit?: Maybe<Scalars['String']['output']>;
};

export type SchedulingDashboardResponse = {
  __typename?: 'SchedulingDashboardResponse';
  items?: Maybe<Array<Maybe<SchedulingDashboard>>>;
};

export type SchedulingGetCapacityUserAssignmentResponse = {
  __typename?: 'SchedulingGetCapacityUserAssignmentResponse';
  filters?: Maybe<Array<Maybe<FilterStructure>>>;
  items?: Maybe<Array<Maybe<UserAssignment>>>;
};

export type SchedulingMaxUtilization = {
  __typename?: 'SchedulingMaxUtilization';
  manDays?: Maybe<Scalars['Float']['output']>;
  maxDaysInMonth?: Maybe<Scalars['Int']['output']>;
  month: Month;
};

export type SchedulingMaxUtilizationResponse = {
  __typename?: 'SchedulingMaxUtilizationResponse';
  items: Array<SchedulingMaxUtilization>;
  totalAllocation: Scalars['Float']['output'];
};

export type SchedulingRow = {
  __typename?: 'SchedulingRow';
  auditPlanName?: Maybe<Scalars['String']['output']>;
  /**  A */
  availability?: Maybe<Scalars['Float']['output']>;
  booked?: Maybe<Scalars['Float']['output']>;
  demand?: Maybe<Scalars['Float']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['String']['output']>;
  expectedStartingDate?: Maybe<Scalars['String']['output']>;
  /** (A-B) */
  forecast?: Maybe<Scalars['Float']['output']>;
  ghoAuditType?: Maybe<Scalars['String']['output']>;
  legalEntityCode?: Maybe<Scalars['String']['output']>;
  /** (A-C) */
  legalEntityName?: Maybe<Scalars['String']['output']>;
  legalEntityTrackingId?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  monthlyBreakdown?: Maybe<MonthlyBreakdown>;
  monthlyBreakdownMaxGql?: Maybe<MonthlyBreakdown>;
  name?: Maybe<Scalars['String']['output']>;
  proposalAdded?: Maybe<Scalars['String']['output']>;
  proposalTrackingId?: Maybe<Scalars['String']['output']>;
  proposedDemand?: Maybe<Scalars['Float']['output']>;
  /**  B */
  residual?: Maybe<Scalars['Float']['output']>;
  /**  C */
  residualForecast?: Maybe<Scalars['Float']['output']>;
  smartcode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SchedulingTotalsAllocationResponse = {
  __typename?: 'SchedulingTotalsAllocationResponse';
  dashboardId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  permission?: Maybe<PermissionType>;
  schedulingRow?: Maybe<SchedulingRow>;
  subnodes?: Maybe<Array<Maybe<SchedulingTotalsAllocationResponse>>>;
};

export type SimpleQueryInput = {
  field: Scalars['String']['input'];
  operator: ComparatorOperators;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SwapExternalTeamMemberInCapacityCampaignInput = {
  capacityPlanningId: Scalars['ID']['input'];
  newTeamMemberId: Scalars['ID']['input'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  campaign?: Maybe<Campaign>;
  capacityType?: Maybe<CapacityType>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  typeOfContract?: Maybe<Scalars['String']['output']>;
};

export type TeamMemberCapacityInput = {
  capacityPlanningId: Scalars['ID']['input'];
};

export type TeamMemberCapacityPlans = {
  __typename?: 'TeamMemberCapacityPlans';
  items?: Maybe<Array<Maybe<CapacityPlan>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type TeamMembers = {
  __typename?: 'TeamMembers';
  items?: Maybe<Array<Maybe<UserProfile>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type UpdateCampaignInput = {
  id: Scalars['ID']['input'];
  status: CampaignStatus;
};

export type UpdateCapacityActivityAllocationInput = {
  id: Scalars['ID']['input'];
  manDaysAllocation?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCapacityActivityAllocationPayload = {
  __typename?: 'UpdateCapacityActivityAllocationPayload';
  allocation?: Maybe<CapacityActivityAllocation>;
  totals?: Maybe<CapacityPlanTotals>;
};

export type UpdateDemandActivityInput = {
  activityPlanningId: Scalars['ID']['input'];
  demand: Scalars['Float']['input'];
};

export type UpdateLegalEntityInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLentedAllocationInput = {
  activityValueChainId?: InputMaybe<Scalars['ID']['input']>;
  allocationPlanningId?: InputMaybe<Scalars['ID']['input']>;
  capacityPlanningId: Scalars['ID']['input'];
  ghoContactType?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  manDaysAllocation?: InputMaybe<Scalars['Float']['input']>;
  organizationalUnit?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateLevel3NameInput = {
  activityPlanningId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManDaysMaxUtilizationInput = {
  dashboardId: Scalars['ID']['input'];
  manDays: Scalars['Float']['input'];
  month: Month;
};

export type UpdateSchedulingAllocationRequest = {
  idSchedulingAllocation: Scalars['ID']['input'];
  monthlyBreakdown?: InputMaybe<MonthlyBreakdownInput>;
};

export type UpdateTeamMemberCapacityPlanInput = {
  blockedPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  capacityPlanningId: Scalars['ID']['input'];
  endPeriodDate?: InputMaybe<Scalars['String']['input']>;
  startPeriodDate?: InputMaybe<Scalars['String']['input']>;
  totalAvailabilityInput?: InputMaybe<Scalars['Float']['input']>;
  workContractAvailability?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateValueChainInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentName?: InputMaybe<Scalars['String']['input']>;
  viewOrder: Scalars['Int']['input'];
};

export type UpsertResult = {
  __typename?: 'UpsertResult';
  data?: Maybe<LentedAllocation>;
  error?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  legalEntity?: Maybe<LegalEntity>;
  userName: Scalars['String']['output'];
};

export type UserAssignment = {
  __typename?: 'UserAssignment';
  currentlyAdded?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  userAssignmentCapacityDetails?: Maybe<UserAssignmentCapacityDetails>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserAssignmentCapacityDetails = {
  __typename?: 'UserAssignmentCapacityDetails';
  capacityActivityAllocations?: Maybe<Array<Maybe<CapacityActivityAllocation>>>;
  capacityPlanId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  legalEntityCode?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  proposedTotalAvailability?: Maybe<Scalars['Float']['output']>;
  totalAvailabilityInput?: Maybe<Scalars['Float']['output']>;
  totalSummedAvailability?: Maybe<Scalars['Float']['output']>;
};

export type UserConnection = ConnectionInfo & {
  __typename?: 'UserConnection';
  edges: Array<Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export enum UserFields {
  CapacityPlanningManagerName = 'CAPACITY_PLANNING_MANAGER_NAME',
  Email = 'EMAIL',
  ExternalCompanyName = 'EXTERNAL_COMPANY_NAME',
  GaltMemberName = 'GALT_MEMBER_NAME',
  LegalEntityCode = 'LEGAL_ENTITY_CODE',
  LegalEntityName = 'LEGAL_ENTITY_NAME',
  PeopleManagerName = 'PEOPLE_MANAGER_NAME',
  Status = 'STATUS',
  TypeOfContact = 'TYPE_OF_CONTACT_',
  Username = 'USERNAME',
  WorkContractAvailability = 'WORK_CONTRACT_AVAILABILITY'
}

export type UserMutationResponse = {
  __typename?: 'UserMutationResponse';
  data?: Maybe<User>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  areaManager?: Maybe<UserRef>;
  auditTeam?: Maybe<AuditTeam>;
  campaignId: Scalars['String']['output'];
  capacityPlanningManager?: Maybe<UserRef>;
  capacityType?: Maybe<CapacityType>;
  email?: Maybe<Scalars['String']['output']>;
  externalCompanyName?: Maybe<Scalars['String']['output']>;
  galtMember?: Maybe<UserRef>;
  id: Scalars['ID']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  legalEntity?: Maybe<LegalEntity>;
  peopleManager?: Maybe<UserRef>;
  status?: Maybe<Scalars['String']['output']>;
  typeOfContact?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  workContractAvailability?: Maybe<Scalars['Float']['output']>;
};

export type UserRef = {
  __typename?: 'UserRef';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * #######################################
 *  User Management GraphQL Types        #
 * #######################################
 */
export type UserResult = User | UserMutationResponse | Users | UsersMutationResponse;

export type UserRole = {
  __typename?: 'UserRole';
  athenaRole?: Maybe<Scalars['String']['output']>;
  planningRole?: Maybe<PlanningRoles>;
};

export type Users = {
  __typename?: 'Users';
  items: Array<Maybe<UserProfile>>;
  pageInfo: PageInfo;
};

export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  data?: Maybe<User>;
  errors?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export type UsersProfileResponse = {
  __typename?: 'UsersProfileResponse';
  items: Array<UserProfile>;
  pageInfo: PageInfo;
};

export type UsersQueryInput = {
  pageRequest: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type ValueChain = {
  __typename?: 'ValueChain';
  active: Scalars['Boolean']['output'];
  campaign?: Maybe<Campaign>;
  children?: Maybe<Array<Maybe<ValueChain>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ValueChain>;
  viewOrder: Scalars['Int']['output'];
};

export type ValueChains = {
  __typename?: 'ValueChains';
  filters?: Maybe<Array<Maybe<FilterStructure>>>;
  items: Array<Maybe<ValueChain>>;
  pageInfo: PageInfo;
};

export type ValueChainsRequestInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  pageRequest: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
};

export type OuActivityPlanningQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type OuActivityPlanningQuery = { __typename?: 'Query', ouActivityPlanning: { __typename?: 'ActivityPlanningDashboard', items: Array<{ __typename?: 'OuActivityPlanning', businessUnit?: string | null, id?: string | null, organizationalUnit?: string | null, totalAvailability?: number | null, totalDemand?: number | null, totalDifference?: number | null } | null>, pageInfo: { __typename?: 'PageInfo', totalItems: number }, filters?: Array<{ __typename?: 'FilterStructure', key?: string | null, filterValue?: string | null, operator?: string | null } | null> | null } };

export type DownloadActivityPlanningDashboardExcelMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type DownloadActivityPlanningDashboardExcelMutation = { __typename?: 'Mutation', downloadActivityPlanningDashboardExcel: { __typename?: 'DownloadActivityPlanningResponse', message?: string | null, status: MutationStatus, data?: { __typename?: 'DownloadFile', content: string, filename: string } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string }> | null } };

export type ActivityNodeFieldsFragment = { __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null };

export type AddLevel3ActivityMutationVariables = Exact<{
  input: AddLevel3ActivityInput;
}>;


export type AddLevel3ActivityMutation = { __typename?: 'Mutation', addLevel3Activity: { __typename?: 'ActivityNodeResponse', message?: string | null, status: MutationStatus, data?: { __typename?: 'ActivityPlanningMutationData', totalDemand?: number | null, totalAvailability?: number | null, totalDifference?: number | null, nodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string } | null> | null } };

export type GetActivityPlanningTreeQueryVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type GetActivityPlanningTreeQuery = { __typename?: 'Query', activityPlanning: { __typename: 'ActivityPlanningResponse', totalDemand?: number | null, totalAvailability?: number | null, totalDifference?: number | null, filters?: Array<{ __typename: 'FilterStructure', key?: string | null, filterValue?: string | null, operator?: string | null } | null> | null, nodes?: Array<{ __typename: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null } };

export type DeleteLevel3ActivityMutationVariables = Exact<{
  input: DeleteLevel3ActivityInput;
}>;


export type DeleteLevel3ActivityMutation = { __typename?: 'Mutation', deleteLevel3Activity: { __typename?: 'ActivityNodeResponse', data?: { __typename?: 'ActivityPlanningMutationData', totalDemand?: number | null, totalAvailability?: number | null, totalDifference?: number | null, nodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null } | null } };

export type DownloadActivityPlanningExcelMutationVariables = Exact<{
  dashboardId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type DownloadActivityPlanningExcelMutation = { __typename?: 'Mutation', downloadActivityPlanningExcel: { __typename?: 'DownloadActivityPlanningResponse', data?: { __typename?: 'DownloadFile', content: string, filename: string } | null } };

export type UpdateDemandMutationVariables = Exact<{
  input: UpdateDemandActivityInput;
}>;


export type UpdateDemandMutation = { __typename?: 'Mutation', updateDemandActivity: { __typename?: 'ActivityNodeResponse', data?: { __typename?: 'ActivityPlanningMutationData', totalDemand?: number | null, totalAvailability?: number | null, totalDifference?: number | null, nodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null } | null } };

export type UpdateLevel3NameMutationVariables = Exact<{
  input: UpdateLevel3NameInput;
}>;


export type UpdateLevel3NameMutation = { __typename?: 'Mutation', updateLevel3Name: { __typename?: 'ActivityNodeResponse', message?: string | null, status: MutationStatus, data?: { __typename?: 'ActivityPlanningMutationData', totalDemand?: number | null, totalAvailability?: number | null, totalDifference?: number | null, nodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, subnodes?: Array<{ __typename?: 'ActivityPlaningNode', id?: string | null, dashboardId?: string | null, parentId?: string | null, activityValueChainId?: string | null, level?: number | null, name?: string | null, demand?: number | null, proposedDemand?: number | null, availability?: number | null, difference?: number | null, legalEntityName?: string | null, legalEntityCode?: string | null, legalEntityTrackingId?: string | null, proposalTrackingId?: string | null, auditPlanName?: string | null, status?: string | null, ghoAuditType?: string | null, smartcode?: string | null, proposalAdded?: string | null, typeOfAudit?: string | null, expectedStartingDate?: string | null, expectedDeliveryDate?: string | null, engagement?: boolean | null, engagementName?: string | null, btaType?: string | null, auditManagerId?: string | null, engagementManagerId?: string | null, engagementStatus?: string | null, engagementTypeOfThematicAudit?: string | null, permission?: PermissionType | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null, lentedAllocationViews?: Array<{ __typename?: 'LentedAllocationView', ou?: string | null, mdAllocation?: number | null } | null> | null } | null> | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string } | null> | null } };

export type GetActivityValueChainQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  pageRequest: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type GetActivityValueChainQuery = { __typename?: 'Query', activityValueChains: { __typename?: 'ValueChains', pageInfo: { __typename?: 'PageInfo', pageSize: number, page: number, totalPages: number, totalItems: number }, items: Array<{ __typename?: 'ValueChain', id: string, viewOrder: number, level: number, name: string, description?: string | null, active: boolean, campaign?: { __typename?: 'Campaign', id?: string | null, status?: CampaignStatus | null, year?: number | null, type?: CampaignType | null } | null, parent?: { __typename?: 'ValueChain', name: string } | null } | null>, filters?: Array<{ __typename?: 'FilterStructure', filterValue?: string | null, key?: string | null, operator?: string | null } | null> | null } };

export type GetActivityValueChainCampaignsQueryVariables = Exact<{
  type: CampaignType;
}>;


export type GetActivityValueChainCampaignsQuery = { __typename?: 'Query', campaignsByType?: { __typename?: 'Campaigns', items: Array<{ __typename?: 'Campaign', year?: number | null, type?: CampaignType | null, status?: CampaignStatus | null, id?: string | null }> } | null };

export type UpdateActivityValueChainMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  parentName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  viewOrder: Scalars['Int']['input'];
}>;


export type UpdateActivityValueChainMutation = { __typename?: 'Mutation', updateValueChain: { __typename?: 'ActiveValueChainMutationResponse', message?: string | null, status: MutationStatus, data?: { __typename?: 'ValueChain', active: boolean, id: string, viewOrder: number, level: number, name: string, description?: string | null, campaign?: { __typename?: 'Campaign', id?: string | null, status?: CampaignStatus | null, year?: number | null, type?: CampaignType | null } | null, parent?: { __typename?: 'ValueChain', name: string } | null } | null, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null } };

export type DeleteValueChainMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteValueChainMutation = { __typename?: 'Mutation', deleteValueChain?: { __typename?: 'ActiveValueChainMutationResponse', status: MutationStatus, message?: string | null, data?: { __typename?: 'ValueChain', active: boolean, id: string, name: string, level: number, description?: string | null, campaign?: { __typename?: 'Campaign', id?: string | null, type?: CampaignType | null, status?: CampaignStatus | null, year?: number | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null } | null };

export type CreateValueChainMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateValueChainMutation = { __typename?: 'Mutation', createNewValueChain: { __typename?: 'ActiveValueChainMutationResponse', status: MutationStatus, message?: string | null, data?: { __typename?: 'ValueChain', active: boolean, description?: string | null, level: number, name: string, id: string, campaign?: { __typename?: 'Campaign', status?: CampaignStatus | null, year?: number | null, id?: string | null, type?: CampaignType | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null } };

export type DownloadActivityValueChainMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type DownloadActivityValueChainMutation = { __typename?: 'Mutation', downloadActivityValueChainExcel: { __typename?: 'DownloadCapacityPlanningResponse', data?: { __typename?: 'DownloadFile', content: string, filename: string } | null } };

export type GetOrganizationalUnitsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetOrganizationalUnitsQuery = { __typename?: 'Query', resourceOrganizationalUnits?: { __typename?: 'Resources', data?: Array<{ __typename?: 'ResourceType', label?: string | null } | null> | null } | null };

export type ResourceOrganizationalUnitsCompleteQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  organizationalUnitSelected: Scalars['String']['input'];
}>;


export type ResourceOrganizationalUnitsCompleteQuery = { __typename?: 'Query', resourceOrganizationalUnitsComplete?: { __typename?: 'Resources', data?: Array<{ __typename?: 'ResourceType', label?: string | null } | null> | null } | null };

export type GetLegalEntitiesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  organizationalUnitSelected: Scalars['String']['input'];
}>;


export type GetLegalEntitiesQuery = { __typename?: 'Query', resourceLegalEntities?: { __typename?: 'ResourcesWithPermission', data?: Array<{ __typename?: 'ResourceTypeWithPermissio', label?: string | null, id?: string | null, permission?: PermissionType | null } | null> | null } | null };

export type GetPeopleManagersQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  legalEntitySelected: Scalars['ID']['input'];
}>;


export type GetPeopleManagersQuery = { __typename?: 'Query', resourcePeopleManagers?: { __typename?: 'Resources', data?: Array<{ __typename?: 'ResourceType', label?: string | null, id?: string | null } | null> | null } | null };

export type GetAuditTeamsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  legalEntitySelected: Scalars['ID']['input'];
  peopleManagerSelected: Scalars['ID']['input'];
}>;


export type GetAuditTeamsQuery = { __typename?: 'Query', resourceAuditTeams?: { __typename?: 'Resources', data?: Array<{ __typename?: 'ResourceType', label?: string | null, id?: string | null } | null> | null } | null };

export type GetGaltMemberQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  organizationalUnitSelected: Scalars['String']['input'];
}>;


export type GetGaltMemberQuery = { __typename?: 'Query', resourceGaltMember?: { __typename?: 'Resources', data?: Array<{ __typename?: 'ResourceType', label?: string | null, id?: string | null } | null> | null } | null };

export type GetTeamMemberQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  capacityType: CapacityType;
}>;


export type GetTeamMemberQuery = { __typename?: 'Query', teamMembersByResourceCategory?: { __typename?: 'TeamMemberCapacityPlans', items?: Array<{ __typename?: 'CapacityPlan', id: string, endPeriodDate?: string | null, startPeriodDate?: string | null, totalAvailabilityCheck?: boolean | null, blockedPlanning?: boolean | null, teamMember?: { __typename?: 'UserProfile', email?: string | null, userName: string, id: string, externalCompanyName?: string | null, status?: string | null, typeOfContact?: string | null, workContractAvailability?: number | null, capacityType?: CapacityType | null, isPlaceholder: boolean, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null, galtMember?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null } | null> | null } | null };

export type GetFirstFormQueryVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
}>;


export type GetFirstFormQuery = { __typename?: 'Query', teamMemberCapacityPlan?: { __typename?: 'CapacityPlan', id: string, campaignId?: string | null, startPeriodDate?: string | null, endPeriodDate?: string | null, workContractAvailability?: number | null, proposedTotalAvailability?: number | null, totalAvailabilityInput?: number | null, totalSummedAvailability?: number | null, totalAvailabilityCheck?: boolean | null, blockedPlanning?: boolean | null } | null };

export type GetCapacityActivityAllocationsQueryVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
}>;


export type GetCapacityActivityAllocationsQuery = { __typename?: 'Query', teamMemberCapacityPlan?: { __typename?: 'CapacityPlan', id: string, campaignId?: string | null, startPeriodDate?: string | null, endPeriodDate?: string | null, workContractAvailability?: number | null, proposedTotalAvailability?: number | null, totalAvailabilityInput?: number | null, totalSummedAvailability?: number | null, totalAvailabilityCheck?: boolean | null, difference?: number | null, lastUpdateTime?: string | null, blockedPlanning?: boolean | null, permission?: PermissionType | null, capacityActivityAllocations?: Array<{ __typename?: 'CapacityActivityAllocation', id?: string | null, manDaysAllocation?: number | null, lentedAllocation?: number | null, activityValueChain?: { __typename?: 'ActivityValueChain', active?: boolean | null, description?: string | null, id: string, level?: number | null, name?: string | null, parent?: { __typename?: 'ActivityValueChain', active?: boolean | null, id: string, name?: string | null, level?: number | null } | null } | null } | null> | null, teamMember?: { __typename?: 'UserProfile', id: string, email?: string | null, userName: string, externalCompanyName?: string | null, status?: string | null, typeOfContact?: string | null, capacityType?: CapacityType | null, isPlaceholder: boolean, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null } | null };

export type CreateExternalFromUserMutationVariables = Exact<{
  teamMemberId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Scalars['ID']['input']>;
  capacityType: CapacityType;
}>;


export type CreateExternalFromUserMutation = { __typename?: 'Mutation', addExternalTeamMemberToCapacityCampaign?: { __typename?: 'CapacityPlanningAddTeamMemberResponse', message?: string | null, status: MutationStatus, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string }> | null, data: { __typename?: 'CapacityPlan', endPeriodDate?: string | null, startPeriodDate?: string | null, totalAvailabilityCheck?: boolean | null, id: string, teamMember?: { __typename?: 'UserProfile', email?: string | null, userName: string, id: string, externalCompanyName?: string | null, status?: string | null, typeOfContact?: string | null, workContractAvailability?: number | null, capacityType?: CapacityType | null, isPlaceholder: boolean, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null } } | null };

export type GetExternalTeamMembersQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  capacityType: CapacityType;
}>;


export type GetExternalTeamMembersQuery = { __typename?: 'Query', externalTeamMembersToBeAdded?: { __typename?: 'TeamMembers', items?: Array<{ __typename?: 'UserProfile', id: string, userName: string } | null> | null } | null };

export type GetPeopleManagerForExternalTeamMembersQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  capacityType: CapacityType;
  existing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPeopleManagerForExternalTeamMembersQuery = { __typename?: 'Query', externalPeopleManagerForTeamMembersToBeAdded?: { __typename?: 'Resources', data?: Array<{ __typename?: 'ResourceType', label?: string | null, id?: string | null } | null> | null } | null };

export type DeleteTeamMemberMutationVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', deleteTeamMemberFromCapacityCampaign?: { __typename?: 'CapacityPlanningAddTeamMemberResponse', message?: string | null, status: MutationStatus, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null, data: { __typename?: 'CapacityPlan', campaignId?: string | null, endPeriodDate?: string | null, totalAvailabilityCheck?: boolean | null, id: string, teamMember?: { __typename?: 'UserProfile', email?: string | null, userName: string, id: string, externalCompanyName?: string | null, status?: string | null, typeOfContact?: string | null, workContractAvailability?: number | null, capacityType?: CapacityType | null, isPlaceholder: boolean, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null } } | null };

export type SwapExternalTeamMemberMutationVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
  newTeamMemberId: Scalars['ID']['input'];
}>;


export type SwapExternalTeamMemberMutation = { __typename?: 'Mutation', swapPlaceHolderToExternalTeamMemberInCapacityCampaign?: { __typename?: 'CapacityPlanningAddTeamMemberResponse', message?: string | null, status: MutationStatus, data: { __typename?: 'CapacityPlan', campaignId?: string | null, endPeriodDate?: string | null, totalAvailabilityCheck?: boolean | null, id: string, proposedTotalAvailability?: number | null, startPeriodDate?: string | null, teamMember?: { __typename?: 'UserProfile', email?: string | null, userName: string, id: string, externalCompanyName?: string | null, status?: string | null, typeOfContact?: string | null, workContractAvailability?: number | null, capacityType?: CapacityType | null, isPlaceholder: boolean, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null }, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string }> | null } | null };

export type RenamePlaceholderMutationVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Scalars['ID']['input']>;
  newTeamMemberName: Scalars['ID']['input'];
  galtMemberId: Scalars['ID']['input'];
}>;


export type RenamePlaceholderMutation = { __typename?: 'Mutation', renamePlaceHolderTeamMemberInCapacityCampaign?: { __typename?: 'CapacityPlanningAddTeamMemberResponse', status: MutationStatus, message?: string | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string }> | null, data: { __typename?: 'CapacityPlan', campaignId?: string | null, endPeriodDate?: string | null, totalAvailabilityCheck?: boolean | null, id: string, proposedTotalAvailability?: number | null, startPeriodDate?: string | null, teamMember?: { __typename?: 'UserProfile', email?: string | null, userName: string, id: string, externalCompanyName?: string | null, status?: string | null, workContractAvailability?: number | null, capacityType?: CapacityType | null, isPlaceholder: boolean, typeOfContact?: string | null, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null, galtMember?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null } } | null };

export type AddPlaceholderMutationVariables = Exact<{
  teamMemberName: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId?: InputMaybe<Scalars['ID']['input']>;
  capacityType: CapacityType;
  galtMemberId: Scalars['ID']['input'];
}>;


export type AddPlaceholderMutation = { __typename?: 'Mutation', addFeatureNewOnboardingTeamMemberToCapacityCampaign?: { __typename?: 'CapacityPlanningAddTeamMemberResponse', status: MutationStatus, message?: string | null, data: { __typename?: 'CapacityPlan', campaignId?: string | null, endPeriodDate?: string | null, totalAvailabilityCheck?: boolean | null, id: string, startPeriodDate?: string | null, proposedTotalAvailability?: number | null, teamMember?: { __typename?: 'UserProfile', email?: string | null, userName: string, id: string, externalCompanyName?: string | null, status?: string | null, typeOfContact?: string | null, workContractAvailability?: number | null, capacityType?: CapacityType | null, isPlaceholder: boolean, peopleManager?: { __typename?: 'UserRef', id: string, name?: string | null } | null, galtMember?: { __typename?: 'UserRef', id: string, name?: string | null } | null } | null }, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string }> | null } | null };

export type UpdateCapacityActivityAllocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  manDaysAllocation: Scalars['Float']['input'];
}>;


export type UpdateCapacityActivityAllocationMutation = { __typename?: 'Mutation', updateCapacityActivityAllocation?: { __typename?: 'CapacityActivityAllocationMutationResponse', status?: MutationStatus | null, message?: string | null, data?: { __typename?: 'UpdateCapacityActivityAllocationPayload', allocation?: { __typename?: 'CapacityActivityAllocation', id?: string | null, manDaysAllocation?: number | null, lentedAllocation?: number | null, capacityPlanningId?: string | null } | null, totals?: { __typename?: 'CapacityPlanTotals', totalSummedAvailability?: number | null, totalAvailabilityInput?: number | null, totalAvailabilityCheck?: boolean | null, lastUpdateTime?: string | null, difference?: number | null } | null } | null, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null } | null> | null } | null };

export type DownloadCapacityPlanningExcelMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  legalEntityId: Scalars['ID']['input'];
  peopleManagerId: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  capacityType: CapacityType;
}>;


export type DownloadCapacityPlanningExcelMutation = { __typename?: 'Mutation', downloadCapacityPlanningExcel: { __typename?: 'DownloadCapacityPlanningResponse', message?: string | null, status: MutationStatus, data?: { __typename?: 'DownloadFile', filename: string, content: string } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string }> | null } };

export type UpdateTeamMemberCapacityPlanMutationVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
  startPeriodDate?: InputMaybe<Scalars['String']['input']>;
  endPeriodDate?: InputMaybe<Scalars['String']['input']>;
  totalAvailabilityInput?: InputMaybe<Scalars['Float']['input']>;
  blockedPlanning?: InputMaybe<Scalars['Boolean']['input']>;
  workContractAvailability?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateTeamMemberCapacityPlanMutation = { __typename?: 'Mutation', updateTeamMemberCapacityPlan?: { __typename?: 'CapacityPlanMutationResponse', status?: MutationStatus | null, message?: string | null, data?: { __typename?: 'CapacityPlan', id: string, campaignId?: string | null, startPeriodDate?: string | null, endPeriodDate?: string | null, proposedTotalAvailability?: number | null, totalAvailabilityInput?: number | null, totalSummedAvailability?: number | null, workContractAvailability?: number | null, totalAvailabilityCheck?: boolean | null, blockedPlanning?: boolean | null, difference?: number | null, lastUpdateTime?: string | null, capacityActivityAllocations?: Array<{ __typename?: 'CapacityActivityAllocation', id?: string | null, manDaysAllocation?: number | null } | null> | null } | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string } | null> | null } | null };

export type GetCapacityActivityAllocationSumQueryVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  peopleManagerIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  capacityType?: InputMaybe<CapacityType>;
  campaignId: Scalars['ID']['input'];
}>;


export type GetCapacityActivityAllocationSumQuery = { __typename?: 'Query', capacityActivityAllocationSum?: Array<{ __typename: 'CapacityActivityAllocationSum', capacityType?: string | null, totals?: { __typename?: 'CapacityActivityAllocationSumTotals', totalSummedAvailability?: number | null, totalLented?: number | null, totalAvailabilityCheck?: boolean | null } | null, activityAllocationList?: Array<{ __typename: 'CapacityActivityAllocation', capacityPlanningId?: string | null, lentedAllocation?: number | null, manDaysAllocation?: number | null, activityValueChain?: { __typename: 'ActivityValueChain', name?: string | null, id: string, parent?: { __typename: 'ActivityValueChain', id: string, name?: string | null } | null } | null } | null> | null } | null> | null };

export type AllocationChangesQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
  since: Scalars['String']['input'];
}>;


export type AllocationChangesQuery = { __typename?: 'Query', allocationChanges?: { __typename?: 'AllocationChangesPayload', lastUpdateTime?: string | null, changes?: Array<{ __typename?: 'CapacityActivityAllocation', manDaysAllocation?: number | null, lentedAllocation?: number | null, id?: string | null, capacityPlanningId?: string | null } | null> | null, totals?: { __typename?: 'CapacityPlanTotals', workContractAvailability?: number | null, totalSummedAvailability?: number | null, totalAvailabilityInput?: number | null, totalAvailabilityCheck?: boolean | null, startPeriodDate?: string | null, proposedTotalAvailability?: number | null, lastUpdateTime?: string | null, endPeriodDate?: string | null, difference?: number | null, blockedPlanning?: boolean | null } | null } | null };

export type GetCapacityPlanningQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  page: PageRequest;
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type GetCapacityPlanningQuery = { __typename?: 'Query', leCapacityPlanning: { __typename?: 'CapacityPlanning', pageInfo: { __typename?: 'PageInfo', totalPages: number, totalItems: number, pageSize: number, page: number }, items: Array<{ __typename?: 'LegalEntityCapacityPlanning', id?: string | null, actualInternalAuditors?: number | null, externalSupport?: number | null, futureNewOnboarding?: number | null, lastValidationDate?: string | null, leCapacityPlanningStatus?: string | null, localChiefValidation?: boolean | null, resourceAllocated?: number | null, totalAvailabilityMD?: number | null, totalTypeOfContact?: number | null, unknownExternalSupport?: number | null, lastValidationUser?: string | null, canValidate?: boolean | null, legalEntity?: { __typename?: 'LegalEntity', code: string, id?: string | null, name: string, businessUnit?: string | null, organizationalUnit?: string | null, legalEntityTrackingId?: string | null, chiefAuditor?: string | null } | null } | null>, filters?: Array<{ __typename?: 'FilterStructure', operator?: string | null, key?: string | null, filterValue?: string | null } | null> | null } };

export type ValidateCapacityPlanningMutationVariables = Exact<{
  capacityLegalEntityId: Scalars['ID']['input'];
}>;


export type ValidateCapacityPlanningMutation = { __typename?: 'Mutation', validateLeCapacityPlanning: { __typename?: 'CapacityPlanningUpdateResponse', status: MutationStatus, message?: string | null, data: { __typename?: 'LegalEntityCapacityPlanning', id?: string | null, actualInternalAuditors?: number | null, externalSupport?: number | null, futureNewOnboarding?: number | null, lastValidationDate?: string | null, leCapacityPlanningStatus?: string | null, localChiefValidation?: boolean | null, resourceAllocated?: number | null, totalAvailabilityMD?: number | null, totalTypeOfContact?: number | null, unknownExternalSupport?: number | null, lastValidationUser?: string | null, canValidate?: boolean | null, legalEntity?: { __typename?: 'LegalEntity', code: string, id?: string | null, name: string, businessUnit?: string | null, organizationalUnit?: string | null, legalEntityTrackingId?: string | null } | null }, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null } };

export type DownloadLeCapacityPlanningExcelMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  query?: InputMaybe<AggregateQueryInput>;
}>;


export type DownloadLeCapacityPlanningExcelMutation = { __typename?: 'Mutation', downloadLeCapacityPlanningExcel: { __typename?: 'DownloadCapacityPlanningResponse', message?: string | null, status: MutationStatus, data?: { __typename?: 'DownloadFile', content: string, filename: string } | null } };

export type CreateCampaignMutationVariables = Exact<{
  year: Scalars['Int']['input'];
  type: CampaignType;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'CampaignMutationResponse', status: MutationStatus, message?: string | null, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null, data?: { __typename?: 'Campaign', year?: number | null, type?: CampaignType | null, id?: string | null, status?: CampaignStatus | null } | null } };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: CampaignStatus;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'CampaignMutationResponse', status: MutationStatus, message?: string | null, errors?: Array<{ __typename?: 'FieldError', message: string, field?: string | null }> | null, data?: { __typename?: 'Campaign', id?: string | null, status?: CampaignStatus | null, type?: CampaignType | null, year?: number | null } | null } };

export type GetTeamMemberLentedAllocationQueryVariables = Exact<{
  capacityPlanningId: Scalars['ID']['input'];
}>;


export type GetTeamMemberLentedAllocationQuery = { __typename?: 'Query', teamMemberLentedAllocation?: Array<{ __typename?: 'LentedAllocation', id: string, legalEntityId?: string | null, organizationalUnit?: string | null, capacityPlanningId?: string | null, manDaysAllocation?: number | null, ghoContactType?: string | null, activityValueChain?: { __typename?: 'ActivityValueChain', id: string, name?: string | null, active?: boolean | null } | null } | null> | null };

export type GetAvailableGhoContactTypesQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  organizationalUnit: Scalars['ID']['input'];
  activityValueChainId: Scalars['ID']['input'];
  capacityPlanningId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAvailableGhoContactTypesQuery = { __typename?: 'Query', availableGhoContactTypes?: Array<string | null> | null };

export type UpdateLentedAllocationMutationVariables = Exact<{
  allocationPlanningId?: InputMaybe<Scalars['ID']['input']>;
  capacityPlanningId: Scalars['ID']['input'];
  activityValueChainId?: InputMaybe<Scalars['ID']['input']>;
  organizationalUnit?: InputMaybe<Scalars['ID']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  manDaysAllocation?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateLentedAllocationMutation = { __typename?: 'Mutation', updateLentedAllocation?: { __typename?: 'LentedAllocationMutationResponse', status?: MutationStatus | null, message?: string | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string } | null> | null, data?: { __typename?: 'LentedAllocation', id: string, capacityPlanningId?: string | null, manDaysAllocation?: number | null, organizationalUnit?: string | null, legalEntityId?: string | null, activityValueChain?: { __typename?: 'ActivityValueChain', id: string, name?: string | null } | null } | null } | null };

export type DeleteLentedAllocationMutationVariables = Exact<{
  allocationPlanningId: Scalars['ID']['input'];
}>;


export type DeleteLentedAllocationMutation = { __typename?: 'Mutation', deleteLentedAllocation?: { __typename?: 'LentedAllocationMutationResponse', status?: MutationStatus | null, message?: string | null, errors?: Array<{ __typename?: 'FieldError', field?: string | null, message: string } | null> | null, data?: { __typename?: 'LentedAllocation', id: string } | null } | null };

export type BulkSaveLentedAllocationsMutationVariables = Exact<{
  upserts?: InputMaybe<Array<LentedAllocationUpsertInput> | LentedAllocationUpsertInput>;
  deletes?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BulkSaveLentedAllocationsMutation = { __typename?: 'Mutation', bulkSaveLentedAllocations?: { __typename?: 'BulkSaveLentedAllocationsPayload', status?: string | null, message?: string | null, upsertResults?: Array<{ __typename?: 'UpsertResult', index: number, success: boolean, error?: string | null, data?: { __typename?: 'LentedAllocation', id: string, capacityPlanningId?: string | null, manDaysAllocation?: number | null, organizationalUnit?: string | null, legalEntityId?: string | null, ghoContactType?: string | null, activityValueChain?: { __typename?: 'ActivityValueChain', id: string, name?: string | null } | null } | null } | null> | null, deleteResults?: Array<{ __typename?: 'DeleteResult', id: string, success: boolean, error?: string | null } | null> | null } | null };

export type GetUserRolePlannerToolQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolePlannerToolQuery = { __typename?: 'Query', userRolePlannerTool?: { __typename?: 'UserRole', athenaRole?: string | null } | null };

export const ActivityNodeFieldsFragmentDoc = gql`
    fragment ActivityNodeFields on ActivityPlaningNode {
  id
  dashboardId
  parentId
  activityValueChainId
  level
  name
  demand
  proposedDemand
  availability
  difference
  legalEntityName
  legalEntityCode
  legalEntityTrackingId
  proposalTrackingId
  auditPlanName
  status
  ghoAuditType
  smartcode
  proposalAdded
  typeOfAudit
  expectedStartingDate
  expectedDeliveryDate
  engagement
  engagementName
  btaType
  auditManagerId
  engagementManagerId
  engagementStatus
  engagementTypeOfThematicAudit
  permission
  lentedAllocationViews {
    ou
    mdAllocation
  }
}
    `;
export const OuActivityPlanningDocument = gql`
    query OuActivityPlanning($campaignId: ID!, $page: Int!, $pageSize: Int!, $query: AggregateQueryInput) {
  ouActivityPlanning(
    request: {campaignId: $campaignId, page: {page: $page, pageSize: $pageSize}, query: $query}
  ) {
    items {
      businessUnit
      id
      organizationalUnit
      totalAvailability
      totalDemand
      totalDifference
    }
    pageInfo {
      totalItems
    }
    filters {
      key
      filterValue
      operator
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OuActivityPlanningGQL extends Apollo.Query<OuActivityPlanningQuery, OuActivityPlanningQueryVariables> {
    document = OuActivityPlanningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadActivityPlanningDashboardExcelDocument = gql`
    mutation DownloadActivityPlanningDashboardExcel($campaignId: ID!, $query: AggregateQueryInput) {
  downloadActivityPlanningDashboardExcel(
    request: {campaignId: $campaignId, page: {page: 0, pageSize: 1000000}, query: $query}
  ) {
    message
    status
    data {
      content
      filename
    }
    errors {
      field
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadActivityPlanningDashboardExcelGQL extends Apollo.Mutation<DownloadActivityPlanningDashboardExcelMutation, DownloadActivityPlanningDashboardExcelMutationVariables> {
    document = DownloadActivityPlanningDashboardExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddLevel3ActivityDocument = gql`
    mutation AddLevel3Activity($input: AddLevel3ActivityInput!) {
  addLevel3Activity(input: $input) {
    message
    status
    data {
      totalDemand
      totalAvailability
      totalDifference
      nodes {
        ...ActivityNodeFields
        subnodes {
          ...ActivityNodeFields
          subnodes {
            ...ActivityNodeFields
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    ${ActivityNodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLevel3ActivityGQL extends Apollo.Mutation<AddLevel3ActivityMutation, AddLevel3ActivityMutationVariables> {
    document = AddLevel3ActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActivityPlanningTreeDocument = gql`
    query GetActivityPlanningTree($dashboardId: ID!, $page: Int!, $pageSize: Int!, $query: AggregateQueryInput) {
  activityPlanning(
    request: {dashboardId: $dashboardId, page: {page: $page, pageSize: $pageSize}, query: $query}
  ) {
    totalDemand
    totalAvailability
    totalDifference
    filters {
      key
      filterValue
      operator
      __typename
    }
    nodes {
      ...ActivityNodeFields
      subnodes {
        ...ActivityNodeFields
        subnodes {
          ...ActivityNodeFields
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    ${ActivityNodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActivityPlanningTreeGQL extends Apollo.Query<GetActivityPlanningTreeQuery, GetActivityPlanningTreeQueryVariables> {
    document = GetActivityPlanningTreeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLevel3ActivityDocument = gql`
    mutation DeleteLevel3Activity($input: DeleteLevel3ActivityInput!) {
  deleteLevel3Activity(input: $input) {
    data {
      totalDemand
      totalAvailability
      totalDifference
      nodes {
        ...ActivityNodeFields
        subnodes {
          ...ActivityNodeFields
          subnodes {
            ...ActivityNodeFields
          }
        }
      }
    }
  }
}
    ${ActivityNodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLevel3ActivityGQL extends Apollo.Mutation<DeleteLevel3ActivityMutation, DeleteLevel3ActivityMutationVariables> {
    document = DeleteLevel3ActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadActivityPlanningExcelDocument = gql`
    mutation DownloadActivityPlanningExcel($dashboardId: ID!, $page: PageRequest!, $query: AggregateQueryInput) {
  downloadActivityPlanningExcel(
    request: {dashboardId: $dashboardId, page: $page, query: $query}
  ) {
    data {
      content
      filename
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadActivityPlanningExcelGQL extends Apollo.Mutation<DownloadActivityPlanningExcelMutation, DownloadActivityPlanningExcelMutationVariables> {
    document = DownloadActivityPlanningExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDemandDocument = gql`
    mutation UpdateDemand($input: UpdateDemandActivityInput!) {
  updateDemandActivity(input: $input) {
    data {
      totalDemand
      totalAvailability
      totalDifference
      nodes {
        ...ActivityNodeFields
        subnodes {
          ...ActivityNodeFields
          subnodes {
            ...ActivityNodeFields
          }
        }
      }
    }
  }
}
    ${ActivityNodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDemandGQL extends Apollo.Mutation<UpdateDemandMutation, UpdateDemandMutationVariables> {
    document = UpdateDemandDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLevel3NameDocument = gql`
    mutation UpdateLevel3Name($input: UpdateLevel3NameInput!) {
  updateLevel3Name(input: $input) {
    data {
      totalDemand
      totalAvailability
      totalDifference
      nodes {
        ...ActivityNodeFields
        subnodes {
          ...ActivityNodeFields
          subnodes {
            ...ActivityNodeFields
          }
        }
      }
    }
    message
    status
    errors {
      field
      message
    }
  }
}
    ${ActivityNodeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLevel3NameGQL extends Apollo.Mutation<UpdateLevel3NameMutation, UpdateLevel3NameMutationVariables> {
    document = UpdateLevel3NameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActivityValueChainDocument = gql`
    query GetActivityValueChain($campaignId: ID!, $pageRequest: PageRequest!, $query: AggregateQueryInput) {
  activityValueChains(
    request: {pageRequest: $pageRequest, query: $query, campaignId: $campaignId}
  ) {
    pageInfo {
      pageSize
      page
      totalPages
      totalItems
    }
    items {
      campaign {
        id
        status
        year
        type
      }
      id
      viewOrder
      level
      name
      description
      active
      parent {
        name
      }
    }
    filters {
      filterValue
      key
      operator
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActivityValueChainGQL extends Apollo.Query<GetActivityValueChainQuery, GetActivityValueChainQueryVariables> {
    document = GetActivityValueChainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetActivityValueChainCampaignsDocument = gql`
    query GetActivityValueChainCampaigns($type: CampaignType!) {
  campaignsByType(type: $type) {
    items {
      year
      type
      status
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActivityValueChainCampaignsGQL extends Apollo.Query<GetActivityValueChainCampaignsQuery, GetActivityValueChainCampaignsQueryVariables> {
    document = GetActivityValueChainCampaignsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActivityValueChainDocument = gql`
    mutation UpdateActivityValueChain($id: ID!, $parentName: String, $name: String!, $description: String, $isActive: Boolean, $viewOrder: Int!) {
  updateValueChain(
    input: {description: $description, id: $id, isActive: $isActive, name: $name, parentName: $parentName, viewOrder: $viewOrder}
  ) {
    data {
      active
      campaign {
        id
        status
        year
        type
      }
      id
      viewOrder
      level
      name
      parent {
        name
      }
      description
    }
    errors {
      message
      field
    }
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActivityValueChainGQL extends Apollo.Mutation<UpdateActivityValueChainMutation, UpdateActivityValueChainMutationVariables> {
    document = UpdateActivityValueChainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteValueChainDocument = gql`
    mutation DeleteValueChain($id: ID!) {
  deleteValueChain(id: $id) {
    data {
      active
      campaign {
        id
        type
        status
        year
      }
      id
      name
      level
      description
    }
    errors {
      message
      field
    }
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteValueChainGQL extends Apollo.Mutation<DeleteValueChainMutation, DeleteValueChainMutationVariables> {
    document = DeleteValueChainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateValueChainDocument = gql`
    mutation CreateValueChain($campaignId: ID!, $parentId: ID, $parentName: String, $name: String!, $description: String) {
  createNewValueChain(
    input: {parentName: $parentName, parentId: $parentId, name: $name, description: $description, campaignId: $campaignId}
  ) {
    status
    data {
      campaign {
        status
        year
        id
        type
      }
      active
      description
      level
      name
      id
    }
    errors {
      message
      field
    }
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateValueChainGQL extends Apollo.Mutation<CreateValueChainMutation, CreateValueChainMutationVariables> {
    document = CreateValueChainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadActivityValueChainDocument = gql`
    mutation DownloadActivityValueChain($campaignId: ID!, $page: Int!, $pageSize: Int!) {
  downloadActivityValueChainExcel(
    request: {pageRequest: {page: $page, pageSize: $pageSize}, campaignId: $campaignId}
  ) {
    data {
      content
      filename
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadActivityValueChainGQL extends Apollo.Mutation<DownloadActivityValueChainMutation, DownloadActivityValueChainMutationVariables> {
    document = DownloadActivityValueChainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationalUnitsDocument = gql`
    query GetOrganizationalUnits($campaignId: ID!) {
  resourceOrganizationalUnits(request: {campaignId: $campaignId}) {
    data {
      label
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationalUnitsGQL extends Apollo.Query<GetOrganizationalUnitsQuery, GetOrganizationalUnitsQueryVariables> {
    document = GetOrganizationalUnitsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResourceOrganizationalUnitsCompleteDocument = gql`
    query ResourceOrganizationalUnitsComplete($campaignId: ID!, $organizationalUnitSelected: String!) {
  resourceOrganizationalUnitsComplete(
    request: {campaignId: $campaignId, organizationalUnitSelected: $organizationalUnitSelected}
  ) {
    data {
      label
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResourceOrganizationalUnitsCompleteGQL extends Apollo.Query<ResourceOrganizationalUnitsCompleteQuery, ResourceOrganizationalUnitsCompleteQueryVariables> {
    document = ResourceOrganizationalUnitsCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLegalEntitiesDocument = gql`
    query GetLegalEntities($campaignId: ID!, $organizationalUnitSelected: String!) {
  resourceLegalEntities(
    request: {campaignId: $campaignId, organizationalUnitSelected: $organizationalUnitSelected}
  ) {
    data {
      label
      id
      permission
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLegalEntitiesGQL extends Apollo.Query<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables> {
    document = GetLegalEntitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPeopleManagersDocument = gql`
    query GetPeopleManagers($campaignId: ID!, $legalEntitySelected: ID!) {
  resourcePeopleManagers(
    request: {campaignId: $campaignId, legalEntitySelected: $legalEntitySelected}
  ) {
    data {
      label
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPeopleManagersGQL extends Apollo.Query<GetPeopleManagersQuery, GetPeopleManagersQueryVariables> {
    document = GetPeopleManagersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuditTeamsDocument = gql`
    query GetAuditTeams($campaignId: ID!, $legalEntitySelected: ID!, $peopleManagerSelected: ID!) {
  resourceAuditTeams(
    request: {campaignId: $campaignId, legalEntitySelected: $legalEntitySelected, peopleManagerSelected: $peopleManagerSelected}
  ) {
    data {
      label
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuditTeamsGQL extends Apollo.Query<GetAuditTeamsQuery, GetAuditTeamsQueryVariables> {
    document = GetAuditTeamsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGaltMemberDocument = gql`
    query GetGaltMember($campaignId: ID!, $organizationalUnitSelected: String!) {
  resourceGaltMember(
    request: {campaignId: $campaignId, organizationalUnitSelected: $organizationalUnitSelected}
  ) {
    data {
      label
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGaltMemberGQL extends Apollo.Query<GetGaltMemberQuery, GetGaltMemberQueryVariables> {
    document = GetGaltMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTeamMemberDocument = gql`
    query GetTeamMember($campaignId: ID!, $legalEntityId: ID!, $peopleManagerId: [ID]!, $capacityType: CapacityType!) {
  teamMembersByResourceCategory(
    request: {campaignId: $campaignId, legalEntityId: $legalEntityId, peopleManagerId: $peopleManagerId, capacityType: $capacityType}
  ) {
    items {
      id
      endPeriodDate
      startPeriodDate
      totalAvailabilityCheck
      blockedPlanning
      teamMember {
        email
        userName
        id
        externalCompanyName
        status
        typeOfContact
        workContractAvailability
        capacityType
        isPlaceholder
        peopleManager {
          id
          name
        }
        galtMember {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamMemberGQL extends Apollo.Query<GetTeamMemberQuery, GetTeamMemberQueryVariables> {
    document = GetTeamMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFirstFormDocument = gql`
    query GetFirstForm($capacityPlanningId: ID!) {
  teamMemberCapacityPlan(request: {capacityPlanningId: $capacityPlanningId}) {
    id
    campaignId
    startPeriodDate
    endPeriodDate
    workContractAvailability
    proposedTotalAvailability
    totalAvailabilityInput
    totalSummedAvailability
    totalAvailabilityCheck
    blockedPlanning
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFirstFormGQL extends Apollo.Query<GetFirstFormQuery, GetFirstFormQueryVariables> {
    document = GetFirstFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCapacityActivityAllocationsDocument = gql`
    query GetCapacityActivityAllocations($capacityPlanningId: ID!) {
  teamMemberCapacityPlan(request: {capacityPlanningId: $capacityPlanningId}) {
    id
    campaignId
    startPeriodDate
    endPeriodDate
    workContractAvailability
    proposedTotalAvailability
    totalAvailabilityInput
    totalSummedAvailability
    totalAvailabilityCheck
    difference
    capacityActivityAllocations {
      id
      manDaysAllocation
      lentedAllocation
      activityValueChain {
        active
        description
        id
        level
        name
        parent {
          active
          id
          name
          level
        }
      }
    }
    teamMember {
      id
      email
      userName
      externalCompanyName
      status
      typeOfContact
      capacityType
      isPlaceholder
      peopleManager {
        id
        name
      }
    }
    lastUpdateTime
    blockedPlanning
    permission
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCapacityActivityAllocationsGQL extends Apollo.Query<GetCapacityActivityAllocationsQuery, GetCapacityActivityAllocationsQueryVariables> {
    document = GetCapacityActivityAllocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExternalFromUserDocument = gql`
    mutation CreateExternalFromUser($teamMemberId: ID!, $campaignId: ID!, $legalEntityId: ID!, $peopleManagerId: ID, $capacityType: CapacityType!) {
  addExternalTeamMemberToCapacityCampaign(
    request: {resourceInput: {campaignId: $campaignId, legalEntityId: $legalEntityId, peopleManagerId: $peopleManagerId, capacityType: $capacityType}, teamMemberId: $teamMemberId}
  ) {
    errors {
      field
      message
    }
    message
    status
    data {
      endPeriodDate
      startPeriodDate
      totalAvailabilityCheck
      teamMember {
        email
        userName
        id
        externalCompanyName
        status
        typeOfContact
        workContractAvailability
        capacityType
        isPlaceholder
        peopleManager {
          id
          name
        }
      }
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExternalFromUserGQL extends Apollo.Mutation<CreateExternalFromUserMutation, CreateExternalFromUserMutationVariables> {
    document = CreateExternalFromUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExternalTeamMembersDocument = gql`
    query GetExternalTeamMembers($campaignId: ID!, $legalEntityId: ID!, $peopleManagerId: [ID], $capacityType: CapacityType!) {
  externalTeamMembersToBeAdded(
    request: {campaignId: $campaignId, legalEntityId: $legalEntityId, peopleManagerId: $peopleManagerId, capacityType: $capacityType}
  ) {
    items {
      id
      userName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExternalTeamMembersGQL extends Apollo.Query<GetExternalTeamMembersQuery, GetExternalTeamMembersQueryVariables> {
    document = GetExternalTeamMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPeopleManagerForExternalTeamMembersDocument = gql`
    query GetPeopleManagerForExternalTeamMembers($campaignId: ID!, $legalEntityId: ID!, $peopleManagerId: [ID], $capacityType: CapacityType!, $existing: Boolean) {
  externalPeopleManagerForTeamMembersToBeAdded(
    request: {campaignId: $campaignId, legalEntityId: $legalEntityId, peopleManagerId: $peopleManagerId, capacityType: $capacityType, existing: $existing}
  ) {
    data {
      label
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPeopleManagerForExternalTeamMembersGQL extends Apollo.Query<GetPeopleManagerForExternalTeamMembersQuery, GetPeopleManagerForExternalTeamMembersQueryVariables> {
    document = GetPeopleManagerForExternalTeamMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTeamMemberDocument = gql`
    mutation DeleteTeamMember($capacityPlanningId: ID!) {
  deleteTeamMemberFromCapacityCampaign(capacityPlanningId: $capacityPlanningId) {
    message
    status
    errors {
      message
      field
    }
    data {
      campaignId
      endPeriodDate
      totalAvailabilityCheck
      teamMember {
        email
        userName
        id
        externalCompanyName
        status
        typeOfContact
        workContractAvailability
        capacityType
        isPlaceholder
        peopleManager {
          id
          name
        }
      }
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTeamMemberGQL extends Apollo.Mutation<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables> {
    document = DeleteTeamMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SwapExternalTeamMemberDocument = gql`
    mutation SwapExternalTeamMember($capacityPlanningId: ID!, $newTeamMemberId: ID!) {
  swapPlaceHolderToExternalTeamMemberInCapacityCampaign(
    request: {capacityPlanningId: $capacityPlanningId, newTeamMemberId: $newTeamMemberId}
  ) {
    data {
      campaignId
      endPeriodDate
      totalAvailabilityCheck
      teamMember {
        email
        userName
        id
        externalCompanyName
        status
        typeOfContact
        workContractAvailability
        capacityType
        isPlaceholder
        peopleManager {
          id
          name
        }
      }
      id
      proposedTotalAvailability
      startPeriodDate
    }
    errors {
      field
      message
    }
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SwapExternalTeamMemberGQL extends Apollo.Mutation<SwapExternalTeamMemberMutation, SwapExternalTeamMemberMutationVariables> {
    document = SwapExternalTeamMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RenamePlaceholderDocument = gql`
    mutation RenamePlaceholder($capacityPlanningId: ID!, $peopleManagerId: ID, $newTeamMemberName: ID!, $galtMemberId: ID!) {
  renamePlaceHolderTeamMemberInCapacityCampaign(
    request: {capacityPlanningId: $capacityPlanningId, peopleManagerId: $peopleManagerId, newTeamMemberName: $newTeamMemberName, galtMemberId: $galtMemberId}
  ) {
    status
    message
    errors {
      field
      message
    }
    data {
      campaignId
      endPeriodDate
      totalAvailabilityCheck
      teamMember {
        email
        userName
        id
        externalCompanyName
        status
        workContractAvailability
        capacityType
        isPlaceholder
        peopleManager {
          id
          name
        }
        galtMember {
          id
          name
        }
        typeOfContact
      }
      id
      proposedTotalAvailability
      startPeriodDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RenamePlaceholderGQL extends Apollo.Mutation<RenamePlaceholderMutation, RenamePlaceholderMutationVariables> {
    document = RenamePlaceholderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPlaceholderDocument = gql`
    mutation AddPlaceholder($teamMemberName: ID!, $campaignId: ID!, $legalEntityId: ID!, $peopleManagerId: ID, $capacityType: CapacityType!, $galtMemberId: ID!) {
  addFeatureNewOnboardingTeamMemberToCapacityCampaign(
    request: {resourceInput: {campaignId: $campaignId, legalEntityId: $legalEntityId, peopleManagerId: $peopleManagerId, capacityType: $capacityType}, teamMemberName: $teamMemberName, galtMemberId: $galtMemberId}
  ) {
    data {
      campaignId
      endPeriodDate
      totalAvailabilityCheck
      teamMember {
        email
        userName
        id
        externalCompanyName
        status
        typeOfContact
        workContractAvailability
        capacityType
        isPlaceholder
        peopleManager {
          id
          name
        }
        galtMember {
          id
          name
        }
      }
      id
      startPeriodDate
      proposedTotalAvailability
    }
    status
    message
    errors {
      field
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPlaceholderGQL extends Apollo.Mutation<AddPlaceholderMutation, AddPlaceholderMutationVariables> {
    document = AddPlaceholderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCapacityActivityAllocationDocument = gql`
    mutation UpdateCapacityActivityAllocation($id: ID!, $manDaysAllocation: Float!) {
  updateCapacityActivityAllocation(
    input: {id: $id, manDaysAllocation: $manDaysAllocation}
  ) {
    status
    message
    data {
      allocation {
        id
        manDaysAllocation
        lentedAllocation
        capacityPlanningId
      }
      totals {
        totalSummedAvailability
        totalAvailabilityInput
        totalAvailabilityCheck
        lastUpdateTime
        difference
      }
    }
    errors {
      message
      field
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCapacityActivityAllocationGQL extends Apollo.Mutation<UpdateCapacityActivityAllocationMutation, UpdateCapacityActivityAllocationMutationVariables> {
    document = UpdateCapacityActivityAllocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadCapacityPlanningExcelDocument = gql`
    mutation DownloadCapacityPlanningExcel($campaignId: ID!, $legalEntityId: ID!, $peopleManagerId: [ID]!, $capacityType: CapacityType!) {
  downloadCapacityPlanningExcel(
    request: {campaignId: $campaignId, legalEntityId: $legalEntityId, peopleManagerId: $peopleManagerId, capacityType: $capacityType}
  ) {
    message
    status
    data {
      filename
      content
    }
    errors {
      field
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadCapacityPlanningExcelGQL extends Apollo.Mutation<DownloadCapacityPlanningExcelMutation, DownloadCapacityPlanningExcelMutationVariables> {
    document = DownloadCapacityPlanningExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTeamMemberCapacityPlanDocument = gql`
    mutation UpdateTeamMemberCapacityPlan($capacityPlanningId: ID!, $startPeriodDate: String, $endPeriodDate: String, $totalAvailabilityInput: Float, $blockedPlanning: Boolean, $workContractAvailability: Float) {
  updateTeamMemberCapacityPlan(
    input: {capacityPlanningId: $capacityPlanningId, startPeriodDate: $startPeriodDate, endPeriodDate: $endPeriodDate, totalAvailabilityInput: $totalAvailabilityInput, blockedPlanning: $blockedPlanning, workContractAvailability: $workContractAvailability}
  ) {
    status
    message
    data {
      id
      campaignId
      startPeriodDate
      endPeriodDate
      proposedTotalAvailability
      totalAvailabilityInput
      totalSummedAvailability
      workContractAvailability
      totalAvailabilityCheck
      blockedPlanning
      difference
      capacityActivityAllocations {
        id
        manDaysAllocation
      }
      lastUpdateTime
    }
    errors {
      field
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTeamMemberCapacityPlanGQL extends Apollo.Mutation<UpdateTeamMemberCapacityPlanMutation, UpdateTeamMemberCapacityPlanMutationVariables> {
    document = UpdateTeamMemberCapacityPlanDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCapacityActivityAllocationSumDocument = gql`
    query GetCapacityActivityAllocationSum($legalEntityId: ID!, $peopleManagerIds: [ID]!, $capacityType: CapacityType, $campaignId: ID!) {
  capacityActivityAllocationSum(
    legalEntityId: $legalEntityId
    peopleManagerIds: $peopleManagerIds
    capacityType: $capacityType
    campaignId: $campaignId
  ) {
    capacityType
    totals {
      totalSummedAvailability
      totalLented
      totalAvailabilityCheck
    }
    activityAllocationList {
      capacityPlanningId
      lentedAllocation
      manDaysAllocation
      activityValueChain {
        name
        parent {
          id
          name
          __typename
        }
        id
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCapacityActivityAllocationSumGQL extends Apollo.Query<GetCapacityActivityAllocationSumQuery, GetCapacityActivityAllocationSumQueryVariables> {
    document = GetCapacityActivityAllocationSumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocationChangesDocument = gql`
    query AllocationChanges($planId: ID!, $since: String!) {
  allocationChanges(planId: $planId, since: $since) {
    lastUpdateTime
    changes {
      manDaysAllocation
      lentedAllocation
      id
      capacityPlanningId
    }
    totals {
      workContractAvailability
      totalSummedAvailability
      totalAvailabilityInput
      totalAvailabilityCheck
      startPeriodDate
      proposedTotalAvailability
      lastUpdateTime
      endPeriodDate
      difference
      blockedPlanning
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocationChangesGQL extends Apollo.Query<AllocationChangesQuery, AllocationChangesQueryVariables> {
    document = AllocationChangesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCapacityPlanningDocument = gql`
    query GetCapacityPlanning($campaignId: ID!, $page: PageRequest!, $query: AggregateQueryInput) {
  leCapacityPlanning(
    request: {campaignId: $campaignId, page: $page, query: $query}
  ) {
    pageInfo {
      totalPages
      totalItems
      pageSize
      page
    }
    items {
      id
      actualInternalAuditors
      externalSupport
      futureNewOnboarding
      lastValidationDate
      legalEntity {
        code
        id
        name
        businessUnit
        organizationalUnit
        legalEntityTrackingId
        chiefAuditor
      }
      leCapacityPlanningStatus
      localChiefValidation
      resourceAllocated
      totalAvailabilityMD
      totalTypeOfContact
      unknownExternalSupport
      lastValidationUser
      canValidate
    }
    filters {
      operator
      key
      filterValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCapacityPlanningGQL extends Apollo.Query<GetCapacityPlanningQuery, GetCapacityPlanningQueryVariables> {
    document = GetCapacityPlanningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateCapacityPlanningDocument = gql`
    mutation ValidateCapacityPlanning($capacityLegalEntityId: ID!) {
  validateLeCapacityPlanning(
    request: {capacityLegalEntityId: $capacityLegalEntityId}
  ) {
    data {
      id
      actualInternalAuditors
      externalSupport
      futureNewOnboarding
      lastValidationDate
      legalEntity {
        code
        id
        name
        businessUnit
        organizationalUnit
        legalEntityTrackingId
      }
      leCapacityPlanningStatus
      localChiefValidation
      resourceAllocated
      totalAvailabilityMD
      totalTypeOfContact
      unknownExternalSupport
      lastValidationUser
      canValidate
    }
    errors {
      message
      field
    }
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateCapacityPlanningGQL extends Apollo.Mutation<ValidateCapacityPlanningMutation, ValidateCapacityPlanningMutationVariables> {
    document = ValidateCapacityPlanningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadLeCapacityPlanningExcelDocument = gql`
    mutation DownloadLeCapacityPlanningExcel($campaignId: ID!, $query: AggregateQueryInput) {
  downloadLeCapacityPlanningExcel(
    request: {campaignId: $campaignId, page: {page: 0, pageSize: 1000000}, query: $query}
  ) {
    data {
      content
      filename
    }
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadLeCapacityPlanningExcelGQL extends Apollo.Mutation<DownloadLeCapacityPlanningExcelMutation, DownloadLeCapacityPlanningExcelMutationVariables> {
    document = DownloadLeCapacityPlanningExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($year: Int!, $type: CampaignType!) {
  createCampaign(request: {year: $year, type: $type}) {
    status
    message
    errors {
      message
      field
    }
    data {
      year
      type
      id
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCampaignGQL extends Apollo.Mutation<CreateCampaignMutation, CreateCampaignMutationVariables> {
    document = CreateCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($id: ID!, $status: CampaignStatus!) {
  updateCampaign(request: {id: $id, status: $status}) {
    status
    message
    errors {
      message
      field
    }
    data {
      id
      status
      type
      year
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCampaignGQL extends Apollo.Mutation<UpdateCampaignMutation, UpdateCampaignMutationVariables> {
    document = UpdateCampaignDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTeamMemberLentedAllocationDocument = gql`
    query GetTeamMemberLentedAllocation($capacityPlanningId: ID!) {
  teamMemberLentedAllocation(request: {capacityPlanningId: $capacityPlanningId}) {
    id
    legalEntityId
    organizationalUnit
    capacityPlanningId
    manDaysAllocation
    ghoContactType
    activityValueChain {
      id
      name
      active
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamMemberLentedAllocationGQL extends Apollo.Query<GetTeamMemberLentedAllocationQuery, GetTeamMemberLentedAllocationQueryVariables> {
    document = GetTeamMemberLentedAllocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAvailableGhoContactTypesDocument = gql`
    query GetAvailableGhoContactTypes($campaignId: ID!, $organizationalUnit: ID!, $activityValueChainId: ID!, $capacityPlanningId: ID) {
  availableGhoContactTypes(
    request: {campaignId: $campaignId, organizationalUnit: $organizationalUnit, activityValueChainId: $activityValueChainId, capacityPlanningId: $capacityPlanningId}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAvailableGhoContactTypesGQL extends Apollo.Query<GetAvailableGhoContactTypesQuery, GetAvailableGhoContactTypesQueryVariables> {
    document = GetAvailableGhoContactTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLentedAllocationDocument = gql`
    mutation UpdateLentedAllocation($allocationPlanningId: ID, $capacityPlanningId: ID!, $activityValueChainId: ID, $organizationalUnit: ID, $legalEntityId: ID, $manDaysAllocation: Float) {
  updateLentedAllocation(
    input: {allocationPlanningId: $allocationPlanningId, capacityPlanningId: $capacityPlanningId, activityValueChainId: $activityValueChainId, legalEntityId: $legalEntityId, manDaysAllocation: $manDaysAllocation, organizationalUnit: $organizationalUnit}
  ) {
    status
    message
    errors {
      field
      message
    }
    data {
      id
      capacityPlanningId
      manDaysAllocation
      organizationalUnit
      legalEntityId
      activityValueChain {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLentedAllocationGQL extends Apollo.Mutation<UpdateLentedAllocationMutation, UpdateLentedAllocationMutationVariables> {
    document = UpdateLentedAllocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLentedAllocationDocument = gql`
    mutation DeleteLentedAllocation($allocationPlanningId: ID!) {
  deleteLentedAllocation(input: {allocationPlanningId: $allocationPlanningId}) {
    status
    message
    errors {
      field
      message
    }
    data {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLentedAllocationGQL extends Apollo.Mutation<DeleteLentedAllocationMutation, DeleteLentedAllocationMutationVariables> {
    document = DeleteLentedAllocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkSaveLentedAllocationsDocument = gql`
    mutation BulkSaveLentedAllocations($upserts: [LentedAllocationUpsertInput!], $deletes: [ID!]) {
  bulkSaveLentedAllocations(input: {upserts: $upserts, deletes: $deletes}) {
    status
    message
    upsertResults {
      index
      success
      error
      data {
        id
        capacityPlanningId
        manDaysAllocation
        organizationalUnit
        legalEntityId
        ghoContactType
        activityValueChain {
          id
          name
        }
      }
    }
    deleteResults {
      id
      success
      error
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkSaveLentedAllocationsGQL extends Apollo.Mutation<BulkSaveLentedAllocationsMutation, BulkSaveLentedAllocationsMutationVariables> {
    document = BulkSaveLentedAllocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserRolePlannerToolDocument = gql`
    query getUserRolePlannerTool {
  userRolePlannerTool {
    athenaRole
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserRolePlannerToolGQL extends Apollo.Query<GetUserRolePlannerToolQuery, GetUserRolePlannerToolQueryVariables> {
    document = GetUserRolePlannerToolDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }